import { ContractFactory, utils, Contract } from 'ethers';

var arbitrum = {
	managingDAOImplementation: "0x741061B01d3A95a7734B594f1884b6c30E0fDA96",
	managingDAO: "0xF3AaA3372EbBf01b923a4Cc98Cd847126b3D73cA",
	ENSRegistry: "0x9277acd65B5dc0F85867Dfd40f5488Be8d47AD18",
	PublicResolver: "0xc4ddBd0472C2688F5d278dAFC02E66EE176C8DE3",
	DAO_ENSSubdomainRegistrar_Implementation: "0xBe6eAC1bA0b2d20AEA9e7924EFEE8E72D6193246",
	DAO_ENSSubdomainRegistrar: "0x57bf333951967a0cC0afcD58FC7959Ca0Eae6905",
	Plugin_ENSSubdomainRegistrar_Implementation: "0x74b3B3504B5d6D1c6247009c9b1e3D8cFF7bd445",
	Plugin_ENSSubdomainRegistrar: "0x6115b7F05cCeF2D883AB64c88ba7e4BD1b877215",
	DAORegistry_Implementation: "0xf2d594F3C93C19D7B1a6F15B5489FFcE4B01f7dA",
	DAORegistry: "0xB5146Fd572C669ABC353902e43F47fda4609E38A",
	PluginRepoRegistry_Implementation: "0x95D563382BeD5AcB458759EE05b27DF2CB019Cc7",
	PluginRepoRegistry: "0xCe0B4124dea6105bfB85fB4461c4D39f360E9ef3",
	PluginRepoFactory: "0xE640Da5AD169630555A86D9b6b9C145B4961b1EB",
	PluginSetupProcessor: "0x308a1DC5020c4B5d992F5543a7236c465997fecB",
	DAOFactory: "0x08633901DdF9cD8e2DC3a073594d0A7DaD6f3f57",
	AddresslistVotingSetup: "0x7a62da7B56fB3bfCdF70E900787010Bc4c9Ca42e",
	GovernanceERC20: "0xddCc39a2a0047Eb47EdF94180452cbaB14d426EF",
	GovernanceWrappedERC20: "0x5B3B36BdC9470963A2734D6a0d2F6a64C21C159f",
	TokenVotingSetup: "0x96E54098317631641703404C06A5afAD89da7373",
	AdminSetup: "0xE978942c691e43f65c1B7c7F8f1dc8cDF061B13f",
	MultisigSetup: "0xA03C2182af8eC460D498108C92E8638a580b94d4",
	PlaceholderSetup: "0x6E924eA5864044D8642385683fFA5AD42FB687f2",
	"address-list-voting-repo": "0xf415FF95166EF5D365fFB3bc6d1701f9e9ed7Df7",
	"token-voting-repo": "0x1AeD2BEb470aeFD65B43f905Bd5371b1E4749d18",
	"admin-repo": "0x326A2aee6A8eE78D79E7E956DE60C6E452f76a8e",
	"multisig-repo": "0x7553E6Fb020c5740768cF289e603770AA09b7aE2"
};
var arbitrumGoerli = {
	managingDAOImplementation: "0x741061B01d3A95a7734B594f1884b6c30E0fDA96",
	managingDAO: "0xF3AaA3372EbBf01b923a4Cc98Cd847126b3D73cA",
	ENSRegistry: "0x9277acd65B5dc0F85867Dfd40f5488Be8d47AD18",
	PublicResolver: "0xc4ddBd0472C2688F5d278dAFC02E66EE176C8DE3",
	DAO_ENSSubdomainRegistrar_Implementation: "0xBe6eAC1bA0b2d20AEA9e7924EFEE8E72D6193246",
	DAO_ENSSubdomainRegistrar: "0x57bf333951967a0cC0afcD58FC7959Ca0Eae6905",
	Plugin_ENSSubdomainRegistrar_Implementation: "0x74b3B3504B5d6D1c6247009c9b1e3D8cFF7bd445",
	Plugin_ENSSubdomainRegistrar: "0x6115b7F05cCeF2D883AB64c88ba7e4BD1b877215",
	DAORegistry_Implementation: "0xf2d594F3C93C19D7B1a6F15B5489FFcE4B01f7dA",
	DAORegistry: "0xB5146Fd572C669ABC353902e43F47fda4609E38A",
	PluginRepoRegistry_Implementation: "0x95D563382BeD5AcB458759EE05b27DF2CB019Cc7",
	PluginRepoRegistry: "0xCe0B4124dea6105bfB85fB4461c4D39f360E9ef3",
	PluginRepoFactory: "0xE640Da5AD169630555A86D9b6b9C145B4961b1EB",
	PluginSetupProcessor: "0x308a1DC5020c4B5d992F5543a7236c465997fecB",
	DAOFactory: "0x08633901DdF9cD8e2DC3a073594d0A7DaD6f3f57",
	AddresslistVotingSetup: "0x7a62da7B56fB3bfCdF70E900787010Bc4c9Ca42e",
	GovernanceERC20: "0xddCc39a2a0047Eb47EdF94180452cbaB14d426EF",
	GovernanceWrappedERC20: "0x5B3B36BdC9470963A2734D6a0d2F6a64C21C159f",
	TokenVotingSetup: "0x96E54098317631641703404C06A5afAD89da7373",
	AdminSetup: "0xE978942c691e43f65c1B7c7F8f1dc8cDF061B13f",
	MultisigSetup: "0xA03C2182af8eC460D498108C92E8638a580b94d4",
	PlaceholderSetup: "0x6E924eA5864044D8642385683fFA5AD42FB687f2",
	"address-list-voting-repo": "0xf415FF95166EF5D365fFB3bc6d1701f9e9ed7Df7",
	"token-voting-repo": "0x1AeD2BEb470aeFD65B43f905Bd5371b1E4749d18",
	"admin-repo": "0x326A2aee6A8eE78D79E7E956DE60C6E452f76a8e",
	"multisig-repo": "0x7553E6Fb020c5740768cF289e603770AA09b7aE2"
};
var sepolia = {
	managingDAOImplementation: "0x57e24f85ceAcDa3Ef4F0fd04005589B88dc01A19",
	managingDAO: "0xCa834B3F404c97273f34e108029eEd776144d324",
	ENSRegistry: "0x005098056a837c2c4F99C7eCeE976F8D90bdFFF8",
	DAO_ENSSubdomainRegistrar_Implementation: "0x005098056a837c2c4F99C7eCeE976F8D90bdFFF8",
	DAO_ENSSubdomainRegistrar: "0xf2d594F3C93C19D7B1a6F15B5489FFcE4B01f7dA",
	Plugin_ENSSubdomainRegistrar_Implementation: "0xB5146Fd572C669ABC353902e43F47fda4609E38A",
	Plugin_ENSSubdomainRegistrar: "0x95D563382BeD5AcB458759EE05b27DF2CB019Cc7",
	DAORegistry_Implementation: "0xE640Da5AD169630555A86D9b6b9C145B4961b1EB",
	DAORegistry: "0x308a1DC5020c4B5d992F5543a7236c465997fecB",
	PluginRepoRegistry_Implementation: "0x08633901DdF9cD8e2DC3a073594d0A7DaD6f3f57",
	PluginRepoRegistry: "0x35B62715459cB60bf6dC17fF8cfe138EA305E7Ee",
	PluginRepoFactory: "0x07f49c49Ce2A99CF7C28F66673d406386BDD8Ff4",
	PluginSetupProcessor: "0xC24188a73dc09aA7C721f96Ad8857B469C01dC9f",
	DAOFactory: "0x7a62da7B56fB3bfCdF70E900787010Bc4c9Ca42e",
	AddresslistVotingSetup: "0xE978942c691e43f65c1B7c7F8f1dc8cDF061B13f",
	GovernanceERC20: "0xA03C2182af8eC460D498108C92E8638a580b94d4",
	GovernanceWrappedERC20: "0x6E924eA5864044D8642385683fFA5AD42FB687f2",
	TokenVotingSetup: "0xadAdd899F1096B77B6fE601748be1A7a9ADB714B",
	AdminSetup: "0xB2CCCB4d7ec56F992219BCF4abe2E7F02003443e",
	MultisigSetup: "0x360586dB62DA31327B2462BA27bEb3e48ebbf396",
	PlaceholderSetup: "0xB2A2b32b9d885C85d5b229C0509341c37CaE7483",
	"address-list-voting-repo": "0xdfA1fBeC1Cad92597101A4f4A18e1340c5eA55C1",
	"token-voting-repo": "0x424F4cA6FA9c24C03f2396DF0E96057eD11CF7dF",
	"admin-repo": "0x152c9E28995E418870b85cbbc0AEE4e53020edb2",
	"multisig-repo": "0x9e7956C8758470dE159481e5DD0d08F8B59217A2"
};
var goerli = {
	managingDAO: "0xB76F8d3512497040a96E77141c951a5374F24Eb9",
	DAO_ENSSubdomainRegistrar_Implementation: "0x394B49Cc32Dc81B8EaCdeb62A6Fa66F31D1D022c",
	DAO_ENSSubdomainRegistrar: "0xC62820f3E74cC82F89100032Ad7F04682F9EdaE0",
	Plugin_ENSSubdomainRegistrar_Implementation: "0xbcE9b6fE957464aF2B739337bd1a936EbFCB5B48",
	Plugin_ENSSubdomainRegistrar: "0xd5656b6d1bc0354073f62AAbc1430530C331979c",
	DAORegistry_Implementation: "0xa796AC80af77a52AdA92778d8fb6133792480B77",
	DAORegistry: "0xd51ac19130A73455F8B3b1c26aFea21D6bA88E54",
	PluginRepoRegistry_Implementation: "0x3861Ef32c1bFcdd53E9AaE4af1C9f47390c17fBf",
	PluginRepoRegistry: "0x970Eb7Dd57c9F0dc4c5a10c06653d1103946b508",
	PluginRepoFactory: "0x477EB3b39C92c38B43778266b09471285e0F7808",
	PluginSetupProcessor: "0xE8B5d8D66a02CD1b9Bd32a4064D7ABa45F51305e",
	DAOFactory: "0x1E4350A3c9aFbDbd70FA30B9B2350B9E8182449a",
	AddresslistVotingSetup: "0x0B295EDeDF122E5A57d0661E1993f617dE1bEDF4",
	TokenVotingSetup: "0x23a21113719ADaf2F360408b82E5cF73c3aA8217",
	AdminSetup: "0x633845bB511DE83EA31b8717614d88fa7b569694",
	MultisigSetup: "0x27469edD65132751aAA4d313d79Ff1b2Fa286380",
	"address-list-voting-repo": "0xbD293e27226EF2b85E84FADCF2d5135AbC52e50A",
	"token-voting-repo": "0xFCc843C48BD44e5dA5976a2f2d85772D59C5959E",
	"admin-repo": "0xF66348E9865bb0f29B889E7c0FE1BCf4acAb5f54",
	"multisig-repo": "0x92C090cffC592B1bC321aCfAF735057B876375F8",
	GovernanceERC20: "0x40d30f08d5F8F1D63FD87309f9e2a6b61EB3dd6D",
	GovernanceWrappedERC20: "0xb16d3b1efed5540c5B96DbEDa58860b327CB0D12"
};
var mainnet = {
	managingDAOImplementation: "0x005098056a837c2c4F99C7eCeE976F8D90bdFFF8",
	managingDAO: "0xf2d594F3C93C19D7B1a6F15B5489FFcE4B01f7dA",
	DAO_ENSSubdomainRegistrar_Implementation: "0xCe0B4124dea6105bfB85fB4461c4D39f360E9ef3",
	DAO_ENSSubdomainRegistrar: "0xE640Da5AD169630555A86D9b6b9C145B4961b1EB",
	Plugin_ENSSubdomainRegistrar_Implementation: "0x08633901DdF9cD8e2DC3a073594d0A7DaD6f3f57",
	Plugin_ENSSubdomainRegistrar: "0x35B62715459cB60bf6dC17fF8cfe138EA305E7Ee",
	DAORegistry_Implementation: "0xC24188a73dc09aA7C721f96Ad8857B469C01dC9f",
	DAORegistry: "0x7a62da7B56fB3bfCdF70E900787010Bc4c9Ca42e",
	PluginRepoRegistry_Implementation: "0xddCc39a2a0047Eb47EdF94180452cbaB14d426EF",
	PluginRepoRegistry: "0x5B3B36BdC9470963A2734D6a0d2F6a64C21C159f",
	PluginRepoFactory: "0x96E54098317631641703404C06A5afAD89da7373",
	PluginSetupProcessor: "0xE978942c691e43f65c1B7c7F8f1dc8cDF061B13f",
	DAOFactory: "0xA03C2182af8eC460D498108C92E8638a580b94d4",
	AddresslistVotingSetup: "0x360586dB62DA31327B2462BA27bEb3e48ebbf396",
	TokenVotingSetup: "0xB2A2b32b9d885C85d5b229C0509341c37CaE7483",
	AdminSetup: "0xBFD541bc4fcE14adf1Fb9258574D3cBF5f55a894",
	MultisigSetup: "0x8d6726Fe85Caa585d88FD8342ebEEE88d703E754",
	"address-list-voting-repo": "0xC207767d8A7a28019AFFAEAe6698F84B5526EbD7",
	"token-voting-repo": "0xb7401cD221ceAFC54093168B814Cc3d42579287f",
	"admin-repo": "0xA4371a239D08bfBA6E8894eccf8466C6323A52C3",
	"multisig-repo": "0x8c278e37D0817210E18A7958524b7D0a1fAA6F7b"
};
var mumbai = {
	managingDAO: "0xE1De373E219a0d19a0500e599adb903477bCA0f9",
	ENSRegistry: "0xD24A78824dF3C29CA03661368e6437b767A5422D",
	PublicResolver: "0xdbFf6be618180E0FF0d74dd3B6BdC1b5de074273",
	DAO_ENSSubdomainRegistrar_Implementation: "0xD5baCA29C944A28f1f568F7e69B119030914c15D",
	DAO_ENSSubdomainRegistrar: "0xC528B8AA6a4D0f21455a06b6D7A41fd795619C31",
	Plugin_ENSSubdomainRegistrar_Implementation: "0x99965D7cFFE21C4AC94526AAFEd33E9EaA27f004",
	Plugin_ENSSubdomainRegistrar: "0x2EfcED958034c3BC455273153C3e604D34C78e46",
	DAORegistry_Implementation: "0xE5058D785C934279Af1EF7E90BB5D58048829256",
	DAORegistry: "0x6dD0C8b7F9406206ceAA01B5576D9d46e9298f0E",
	PluginRepoRegistry_Implementation: "0xab27e29F579C870F66F48F4825A4D294AE540818",
	PluginRepoRegistry: "0xc796bB1AfEBc56daDF6CAcD2aDa78055e5381971",
	PluginRepoFactory: "0x4E7c97ab08c046A8e43571f9839d768ae84492e4",
	PluginSetupProcessor: "0x9227b311C5cecB416707F1C8B7Ca1b52649AabEc",
	DAOFactory: "0xc715336B5E7F10294F36CA09f19A0493070E2eFB",
	AddresslistVotingSetup: "0xfDB0E4AADEf463824F10D6a0455acdb50a81B746",
	TokenVotingSetup: "0xA8c6C249f4739A4d4d0949550a61de7A4b8FDa16",
	AdminSetup: "0x40a3EF0f0780e044EbDDEdAa9AB225158f315afd",
	MultisigSetup: "0x008472798D9818F8BfC08e7966bd9c5d8378FF6f",
	"address-list-voting-repo": "0x71570268A86A80B5cCa3F5e430c2BAa3F4b26278",
	"token-voting-repo": "0xaCa70D8c462940B839DE386BcDD4CACf745632cA",
	"admin-repo": "0x0DF9b15550fF39149e491dDD154b28f587e0cD16",
	"multisig-repo": "0x2c4690b8be39adAd4F15A69340d5035aC6E53eEF",
	GovernanceERC20: "0x10482C2ba761283f516354c85c40450B52F03AAB",
	GovernanceWrappedERC20: "0x861f2138632a2f8aC2B4CeA8A5Ab176543f78f5d"
};
var polygon = {
	AddresslistVotingSetup: "0x622DB36633643E4A4075ecc3A309a4f0B942922a",
	AdminSetup: "0x82aBAfBf46759358c705c7E323543A7Be47AbAf0",
	managingDAO: "0x6d4FB6Ff01A172774f42789fcfcdd84E68c28494",
	DAOFactory: "0x51Ead12DEcD31ea75e1046EdFAda14dd639789b8",
	DAORegistry: "0x96E54098317631641703404C06A5afAD89da7373",
	DAORegistry_Implementation: "0x5B3B36BdC9470963A2734D6a0d2F6a64C21C159f",
	DAO_ENSSubdomainRegistrar: "0x07f49c49Ce2A99CF7C28F66673d406386BDD8Ff4",
	DAO_ENSSubdomainRegistrar_Implementation: "0x35B62715459cB60bf6dC17fF8cfe138EA305E7Ee",
	managingDAOImplementation: "0xCa834B3F404c97273f34e108029eEd776144d324",
	ENSRegistry: "0x57bf333951967a0cC0afcD58FC7959Ca0Eae6905",
	PluginRepoFactory: "0x6E924eA5864044D8642385683fFA5AD42FB687f2",
	PluginRepoRegistry: "0xA03C2182af8eC460D498108C92E8638a580b94d4",
	PluginRepoRegistry_Implementation: "0xE978942c691e43f65c1B7c7F8f1dc8cDF061B13f",
	PluginSetupProcessor: "0x879D9dfe3F36d7684BeC1a2bB4Aa8E8871A7245B",
	Plugin_ENSSubdomainRegistrar: "0x7a62da7B56fB3bfCdF70E900787010Bc4c9Ca42e",
	Plugin_ENSSubdomainRegistrar_Implementation: "0xC24188a73dc09aA7C721f96Ad8857B469C01dC9f",
	PublicResolver: "0x74b3B3504B5d6D1c6247009c9b1e3D8cFF7bd445",
	TokenVotingSetup: "0x03445b197271CB3BE5E453745eD98a05793a4538",
	MultisigSetup: "0xD63A8Cfb0eec960C3e70F96a9e3F3091f3FD70b6",
	"address-list-voting-repo": "0x641DdEdc2139d9948e8dcC936C1Ab2314D9181E6",
	"token-voting-repo": "0xae67aea0B830ed4504B36670B5Fa70c5C386Bb58",
	"admin-repo": "0x7fF570473d0876db16A59e8F04EE7F17Ab117309",
	"multisig-repo": "0x5A5035E7E8aeff220540F383a9cf8c35929bcF31"
};
var baseGoerli = {
	managingDAOImplementation: "0x82aBAfBf46759358c705c7E323543A7Be47AbAf0",
	managingDAO: "0xD63A8Cfb0eec960C3e70F96a9e3F3091f3FD70b6",
	ENSRegistry: "0x9bD1EF0C495F6b078d9A82586A35F4d623384E97",
	PublicResolver: "0x818428f875943eE7c0366de1AAa174a1225dC4eA",
	DAO_ENSSubdomainRegistrar_Implementation: "0xD47f4ea555FFe3A16Bb997e90C2c4A51CC6d823A",
	DAO_ENSSubdomainRegistrar: "0xBB1F7ACf2068Ec3F669FDCB4d0Ad9a70E3E418d6",
	Plugin_ENSSubdomainRegistrar_Implementation: "0x78E839210aa3072ce638A2d6b08DA611ca361A0E",
	Plugin_ENSSubdomainRegistrar: "0x76d72457990e07dd889Bd8F19a02feB89d11A946",
	DAORegistry_Implementation: "0x21D9B7b3D7280e9DA46769f79FffEC4cdf64D1cc",
	DAORegistry: "0xB5eB5C011827C9F5787ceE3Abc72d247E36a5a0D",
	PluginRepoRegistry_Implementation: "0xE47C0B1Ea698F2914b6CC218cdC3A5Ca4FAcff18",
	PluginRepoRegistry: "0x91a851E9Ed7F2c6d41b15F76e4a88f5A37067cC9",
	PluginRepoFactory: "0x1B6632D1357D26055D6452E3b3BEBd1c1d982e86",
	PluginSetupProcessor: "0x6095b5004c59301f8Bb98768Bd395d0bc637C893",
	DAOFactory: "0x3E773BCb6a8C5ED2f23BF167284DF45D9A550fF6",
	AddresslistVotingSetup: "0x7870837ffe670E62d4e601393D454f1b8649F7f9",
	GovernanceERC20: "0x58cd7d773389F68250338C13A1BB5662CFBd0C9A",
	GovernanceWrappedERC20: "0xB815791c233807D39b7430127975244B36C19C8e",
	TokenVotingSetup: "0x399Ce2a71ef78bE6890EB628384dD09D4382a7f0",
	AdminSetup: "0xFcaBf5b75473447E4fde4043F8255B2DAdbF0782",
	MultisigSetup: "0x9148970d7C54FEF15565c1b6C41195d92962CA23",
	PlaceholderSetup: "0xb163e7606847E86A6ecd8c40432A3c75d27dBD80",
	"address-list-voting-repo": "0x38177F525C4BC8427Fe5496fcEA567E7396f9Bba",
	"token-voting-repo": "0x0bdd1C7dD81000777Efcba4BBCeAdBF75560e0b8",
	"admin-repo": "0x64Ee23C65bFBfEC35d337Ae93fcf22137c2E9c13",
	"multisig-repo": "0x3308fd88Db88e11c4d99EC805836d7E9F181CdE0"
};
var baseMainnet = {
	managingDAOImplementation: "0x03445b197271CB3BE5E453745eD98a05793a4538",
	managingDAO: "0x264308C03feAfA071C97b73b09E911530CCCd216",
	ENSRegistry: "0xE3625B9Ed80306f590Dcf8a0d50b193F28DB969E",
	PublicResolver: "0x09AF4b83A9a7EA682A2Eb61d1d0B9e89103b1A06",
	DAO_ENSSubdomainRegistrar_Implementation: "0x7DC8d6d35070A13192C754CF96CB046615f2a3E0",
	DAO_ENSSubdomainRegistrar: "0x91f190a6f6E38042e3398B3f78Eb7e0AF58Ac8c3",
	Plugin_ENSSubdomainRegistrar_Implementation: "0xD47f4ea555FFe3A16Bb997e90C2c4A51CC6d823A",
	Plugin_ENSSubdomainRegistrar: "0xBB1F7ACf2068Ec3F669FDCB4d0Ad9a70E3E418d6",
	DAORegistry_Implementation: "0x76d72457990e07dd889Bd8F19a02feB89d11A946",
	DAORegistry: "0xeB98a71d69a1e12B62c10368D9dA5364CE0f7178",
	PluginRepoRegistry_Implementation: "0x21D9B7b3D7280e9DA46769f79FffEC4cdf64D1cc",
	PluginRepoRegistry: "0xB5eB5C011827C9F5787ceE3Abc72d247E36a5a0D",
	PluginRepoFactory: "0xE47C0B1Ea698F2914b6CC218cdC3A5Ca4FAcff18",
	PluginSetupProcessor: "0x91a851E9Ed7F2c6d41b15F76e4a88f5A37067cC9",
	DAOFactory: "0x1B6632D1357D26055D6452E3b3BEBd1c1d982e86",
	AddresslistVotingSetup: "0xC8109e7B790346F662C6e4ef2bA863a9700cA8Eb",
	GovernanceERC20: "0xd8C229F3644576b200319cB3919B0E87716f47d8",
	GovernanceWrappedERC20: "0x7870837ffe670E62d4e601393D454f1b8649F7f9",
	TokenVotingSetup: "0x58cd7d773389F68250338C13A1BB5662CFBd0C9A",
	AdminSetup: "0xB815791c233807D39b7430127975244B36C19C8e",
	MultisigSetup: "0x399Ce2a71ef78bE6890EB628384dD09D4382a7f0",
	PlaceholderSetup: "0xFcaBf5b75473447E4fde4043F8255B2DAdbF0782",
	"address-list-voting-repo": "0x0A5387021B2722E983842fA701D0BaD8B9279fE2",
	"token-voting-repo": "0x2532570DcFb749A7F976136CC05648ef2a0f60b0",
	"admin-repo": "0x212eF339C77B3390599caB4D46222D79fAabcb5c",
	"multisig-repo": "0xcDC4b0BC63AEfFf3a7826A19D101406C6322A585"
};
var activeContracts = {
	arbitrum: arbitrum,
	arbitrumGoerli: arbitrumGoerli,
	sepolia: sepolia,
	goerli: goerli,
	mainnet: mainnet,
	mumbai: mumbai,
	polygon: polygon,
	baseGoerli: baseGoerli,
	baseMainnet: baseMainnet
};

/* Autogenerated file. Do not edit manually. */
const _abi$1t = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "ActionFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "AnyAddressDisallowedForWhoAndWhere",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionInterfacNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionNotAContract",
        type: "error",
    },
    {
        inputs: [],
        name: "GrantWithConditionNotSupported",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientGas",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "expected",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "NativeTokenDepositAmountMismatch",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "currentCondition",
                type: "address",
            },
            {
                internalType: "address",
                name: "newCondition",
                type: "address",
            },
        ],
        name: "PermissionAlreadyGrantedForDifferentCondition",
        type: "error",
    },
    {
        inputs: [],
        name: "PermissionsForAnyAddressDisallowed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8[3]",
                name: "protocolVersion",
                type: "uint8[3]",
            },
        ],
        name: "ProtocolVersionUpgradeNotSupported",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrantCall",
        type: "error",
    },
    {
        inputs: [],
        name: "TooManyActions",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "Unauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "callbackSelector",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "magicNumber",
                type: "bytes4",
            },
        ],
        name: "UnkownCallback",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAmount",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes4",
                name: "sig",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "CallbackReceived",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "_reference",
                type: "string",
            },
        ],
        name: "Deposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "actor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "callId",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "failureMap",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "execResults",
                type: "bytes[]",
            },
        ],
        name: "Executed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "condition",
                type: "address",
            },
        ],
        name: "Granted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "MetadataSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "NativeTokenDeposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "daoURI",
                type: "string",
            },
        ],
        name: "NewURI",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
        ],
        name: "Revoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "signatureValidator",
                type: "address",
            },
        ],
        name: "SignatureValidatorSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "callbackSelector",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "magicNumber",
                type: "bytes4",
            },
        ],
        name: "StandardCallbackRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "forwarder",
                type: "address",
            },
        ],
        name: "TrustedForwarderSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "nonpayable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "EXECUTE_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "REGISTER_STANDARD_CALLBACK_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ROOT_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SET_METADATA_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SET_SIGNATURE_VALIDATOR_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SET_TRUSTED_FORWARDER_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_DAO_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "_items",
                type: "tuple[]",
            },
        ],
        name: "applyMultiTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.SingleTargetPermission[]",
                name: "items",
                type: "tuple[]",
            },
        ],
        name: "applySingleTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "daoURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_reference",
                type: "string",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_callId",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "_allowFailureMap",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes[]",
                name: "execResults",
                type: "bytes[]",
            },
            {
                internalType: "uint256",
                name: "failureMap",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getTrustedForwarder",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "grant",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "contract IPermissionCondition",
                name: "_condition",
                type: "address",
            },
        ],
        name: "grantWithCondition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "hasPermission",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "_initialOwner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_trustedForwarder",
                type: "address",
            },
            {
                internalType: "string",
                name: "daoURI_",
                type: "string",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8[3]",
                name: "_previousProtocolVersion",
                type: "uint8[3]",
            },
            {
                internalType: "bytes",
                name: "_initData",
                type: "bytes",
            },
        ],
        name: "initializeFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolVersion",
        outputs: [
            {
                internalType: "uint8[3]",
                name: "",
                type: "uint8[3]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "_callbackSelector",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "_magicNumber",
                type: "bytes4",
            },
        ],
        name: "registerStandardCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "revoke",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newDaoURI",
                type: "string",
            },
        ],
        name: "setDaoURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
        ],
        name: "setMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_signatureValidator",
                type: "address",
            },
        ],
        name: "setSignatureValidator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newTrustedForwarder",
                type: "address",
            },
        ],
        name: "setTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "signatureValidator",
        outputs: [
            {
                internalType: "contract IERC1271",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode$_ = "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";
const isSuperArgs$_ = (xs) => xs.length > 1;
class DAO__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$_(args)) {
            super(...args);
        }
        else {
            super(_abi$1t, _bytecode$_, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$1t);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1t, signerOrProvider);
    }
}
DAO__factory.bytecode = _bytecode$_;
DAO__factory.abi = _abi$1t;

/* Autogenerated file. Do not edit manually. */
const _abi$1s = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "_reference",
                type: "string",
            },
        ],
        name: "Deposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "actor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "callId",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "failureMap",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "execResults",
                type: "bytes[]",
            },
        ],
        name: "Executed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "MetadataSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "NativeTokenDeposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "signatureValidator",
                type: "address",
            },
        ],
        name: "SignatureValidatorSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "callbackSelector",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "magicNumber",
                type: "bytes4",
            },
        ],
        name: "StandardCallbackRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "forwarder",
                type: "address",
            },
        ],
        name: "TrustedForwarderSet",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_reference",
                type: "string",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_callId",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "_allowFailureMap",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes[]",
                name: "",
                type: "bytes[]",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getTrustedForwarder",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "hasPermission",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "_callbackSelector",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "_magicNumber",
                type: "bytes4",
            },
        ],
        name: "registerStandardCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
        ],
        name: "setMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_signatureValidator",
                type: "address",
            },
        ],
        name: "setSignatureValidator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_trustedForwarder",
                type: "address",
            },
        ],
        name: "setTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IDAO__factory {
    static createInterface() {
        return new utils.Interface(_abi$1s);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1s, signerOrProvider);
    }
}
IDAO__factory.abi = _abi$1s;

/* Autogenerated file. Do not edit manually. */
const _abi$1r = [
    {
        inputs: [],
        name: "daoURI",
        outputs: [
            {
                internalType: "string",
                name: "_daoURI",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class IEIP4824__factory {
    static createInterface() {
        return new utils.Interface(_abi$1r);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1r, signerOrProvider);
    }
}
IEIP4824__factory.abi = _abi$1r;

/* Autogenerated file. Do not edit manually. */

var index$P = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DAO__factory: DAO__factory,
  IDAO__factory: IDAO__factory,
  IEIP4824__factory: IEIP4824__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$1q = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "isPermitted",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class IPermissionCondition__factory {
    static createInterface() {
        return new utils.Interface(_abi$1q);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1q, signerOrProvider);
    }
}
IPermissionCondition__factory.abi = _abi$1q;

/* Autogenerated file. Do not edit manually. */
const _abi$1p = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "isPermitted",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class PermissionCondition__factory {
    static createInterface() {
        return new utils.Interface(_abi$1p);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1p, signerOrProvider);
    }
}
PermissionCondition__factory.abi = _abi$1p;

/* Autogenerated file. Do not edit manually. */
const _abi$1o = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "isPermitted",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class PermissionConditionUpgradeable__factory {
    static createInterface() {
        return new utils.Interface(_abi$1o);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1o, signerOrProvider);
    }
}
PermissionConditionUpgradeable__factory.abi = _abi$1o;

/* Autogenerated file. Do not edit manually. */
const _abi$1n = [
    {
        inputs: [],
        name: "NO_CONDITION",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$Z = "0x609e610038600b82828239805160001a607314602b57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe730000000000000000000000000000000000000000301460806040526004361060335760003560e01c80636dd02a5b146038575b600080fd5b603f600081565b60405173ffffffffffffffffffffffffffffffffffffffff909116815260200160405180910390f3fea2646970667358221220236614e8ae89442af681341fb501fb6a0f5c1eab194137cd82be2da4c458667964736f6c63430008110033";
const isSuperArgs$Z = (xs) => xs.length > 1;
class PermissionLib__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$Z(args)) {
            super(...args);
        }
        else {
            super(_abi$1n, _bytecode$Z, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$1n);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1n, signerOrProvider);
    }
}
PermissionLib__factory.bytecode = _bytecode$Z;
PermissionLib__factory.abi = _abi$1n;

/* Autogenerated file. Do not edit manually. */
const _abi$1m = [
    {
        inputs: [],
        name: "AnyAddressDisallowedForWhoAndWhere",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionInterfacNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionNotAContract",
        type: "error",
    },
    {
        inputs: [],
        name: "GrantWithConditionNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "currentCondition",
                type: "address",
            },
            {
                internalType: "address",
                name: "newCondition",
                type: "address",
            },
        ],
        name: "PermissionAlreadyGrantedForDifferentCondition",
        type: "error",
    },
    {
        inputs: [],
        name: "PermissionsForAnyAddressDisallowed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "Unauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "condition",
                type: "address",
            },
        ],
        name: "Granted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
        ],
        name: "Revoked",
        type: "event",
    },
    {
        inputs: [],
        name: "ROOT_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "_items",
                type: "tuple[]",
            },
        ],
        name: "applyMultiTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.SingleTargetPermission[]",
                name: "items",
                type: "tuple[]",
            },
        ],
        name: "applySingleTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "grant",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "contract IPermissionCondition",
                name: "_condition",
                type: "address",
            },
        ],
        name: "grantWithCondition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "revoke",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class PermissionManager__factory {
    static createInterface() {
        return new utils.Interface(_abi$1m);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1m, signerOrProvider);
    }
}
PermissionManager__factory.abi = _abi$1m;

/* Autogenerated file. Do not edit manually. */

var index$O = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IPermissionCondition__factory: IPermissionCondition__factory,
  PermissionCondition__factory: PermissionCondition__factory,
  PermissionConditionUpgradeable__factory: PermissionConditionUpgradeable__factory,
  PermissionLib__factory: PermissionLib__factory,
  PermissionManager__factory: PermissionManager__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$1l = [
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class DaoAuthorizable__factory {
    static createInterface() {
        return new utils.Interface(_abi$1l);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1l, signerOrProvider);
    }
}
DaoAuthorizable__factory.abi = _abi$1l;

/* Autogenerated file. Do not edit manually. */
const _abi$1k = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class DaoAuthorizableUpgradeable__factory {
    static createInterface() {
        return new utils.Interface(_abi$1k);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1k, signerOrProvider);
    }
}
DaoAuthorizableUpgradeable__factory.abi = _abi$1k;

/* Autogenerated file. Do not edit manually. */

var index$N = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DaoAuthorizable__factory: DaoAuthorizable__factory,
  DaoAuthorizableUpgradeable__factory: DaoAuthorizableUpgradeable__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$1j = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "definingContract",
                type: "address",
            },
        ],
        name: "MembershipContractAnnounced",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isMember",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class IMembership__factory {
    static createInterface() {
        return new utils.Interface(_abi$1j);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1j, signerOrProvider);
    }
}
IMembership__factory.abi = _abi$1j;

/* Autogenerated file. Do not edit manually. */

var index$M = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IMembership__factory: IMembership__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$1i = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class IProposal__factory {
    static createInterface() {
        return new utils.Interface(_abi$1i);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1i, signerOrProvider);
    }
}
IProposal__factory.abi = _abi$1i;

/* Autogenerated file. Do not edit manually. */
const _abi$1h = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class Proposal__factory {
    static createInterface() {
        return new utils.Interface(_abi$1h);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1h, signerOrProvider);
    }
}
Proposal__factory.abi = _abi$1h;

/* Autogenerated file. Do not edit manually. */
const _abi$1g = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class ProposalUpgradeable__factory {
    static createInterface() {
        return new utils.Interface(_abi$1g);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1g, signerOrProvider);
    }
}
ProposalUpgradeable__factory.abi = _abi$1g;

/* Autogenerated file. Do not edit manually. */

var index$L = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IProposal__factory: IProposal__factory,
  Proposal__factory: Proposal__factory,
  ProposalUpgradeable__factory: ProposalUpgradeable__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$1f = [
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class IPlugin__factory {
    static createInterface() {
        return new utils.Interface(_abi$1f);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1f, signerOrProvider);
    }
}
IPlugin__factory.abi = _abi$1f;

/* Autogenerated file. Do not edit manually. */
const _abi$1e = [
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class Plugin__factory {
    static createInterface() {
        return new utils.Interface(_abi$1e);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1e, signerOrProvider);
    }
}
Plugin__factory.abi = _abi$1e;

/* Autogenerated file. Do not edit manually. */
const _abi$1d = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class PluginCloneable__factory {
    static createInterface() {
        return new utils.Interface(_abi$1d);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1d, signerOrProvider);
    }
}
PluginCloneable__factory.abi = _abi$1d;

/* Autogenerated file. Do not edit manually. */
const _abi$1c = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
class PluginUUPSUpgradeable__factory {
    static createInterface() {
        return new utils.Interface(_abi$1c);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1c, signerOrProvider);
    }
}
PluginUUPSUpgradeable__factory.abi = _abi$1c;

/* Autogenerated file. Do not edit manually. */

var index$K = /*#__PURE__*/Object.freeze({
  __proto__: null,
  daoAuthorizable: index$N,
  membership: index$M,
  proposal: index$L,
  IPlugin__factory: IPlugin__factory,
  Plugin__factory: Plugin__factory,
  PluginCloneable__factory: PluginCloneable__factory,
  PluginUUPSUpgradeable__factory: PluginUUPSUpgradeable__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$1b = [
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "callbackSelector",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "magicNumber",
                type: "bytes4",
            },
        ],
        name: "UnkownCallback",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes4",
                name: "sig",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "CallbackReceived",
        type: "event",
    },
];
class CallbackHandler__factory {
    static createInterface() {
        return new utils.Interface(_abi$1b);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1b, signerOrProvider);
    }
}
CallbackHandler__factory.abi = _abi$1b;

/* Autogenerated file. Do not edit manually. */

var index$J = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CallbackHandler__factory: CallbackHandler__factory
});

/* Autogenerated file. Do not edit manually. */

var index$I = /*#__PURE__*/Object.freeze({
  __proto__: null,
  dao: index$P,
  permission: index$O,
  plugin: index$K,
  utils: index$J
});

/* Autogenerated file. Do not edit manually. */
const _abi$1a = [
    {
        inputs: [
            {
                internalType: "contract DAORegistry",
                name: "_registry",
                type: "address",
            },
            {
                internalType: "contract PluginSetupProcessor",
                name: "_pluginSetupProcessor",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "NoPluginProvided",
        type: "error",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "trustedForwarder",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "daoURI",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "subdomain",
                        type: "string",
                    },
                    {
                        internalType: "bytes",
                        name: "metadata",
                        type: "bytes",
                    },
                ],
                internalType: "struct DAOFactory.DAOSettings",
                name: "_daoSettings",
                type: "tuple",
            },
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "release",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint16",
                                        name: "build",
                                        type: "uint16",
                                    },
                                ],
                                internalType: "struct PluginRepo.Tag",
                                name: "versionTag",
                                type: "tuple",
                            },
                            {
                                internalType: "contract PluginRepo",
                                name: "pluginSetupRepo",
                                type: "address",
                            },
                        ],
                        internalType: "struct PluginSetupRef",
                        name: "pluginSetupRef",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct DAOFactory.PluginSettings[]",
                name: "_pluginSettings",
                type: "tuple[]",
            },
        ],
        name: "createDao",
        outputs: [
            {
                internalType: "contract DAO",
                name: "createdDao",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "daoBase",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "daoRegistry",
        outputs: [
            {
                internalType: "contract DAORegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginSetupProcessor",
        outputs: [
            {
                internalType: "contract PluginSetupProcessor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolVersion",
        outputs: [
            {
                internalType: "uint8[3]",
                name: "",
                type: "uint8[3]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$Y = "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";
const isSuperArgs$Y = (xs) => xs.length > 1;
class DAOFactory__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$Y(args)) {
            super(...args);
        }
        else {
            super(_abi$1a, _bytecode$Y, args[0]);
        }
    }
    deploy(_registry, _pluginSetupProcessor, overrides) {
        return super.deploy(_registry, _pluginSetupProcessor, overrides || {});
    }
    getDeployTransaction(_registry, _pluginSetupProcessor, overrides) {
        return super.getDeployTransaction(_registry, _pluginSetupProcessor, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$1a);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1a, signerOrProvider);
    }
}
DAOFactory__factory.bytecode = _bytecode$Y;
DAOFactory__factory.abi = _abi$1a;

/* Autogenerated file. Do not edit manually. */
const _abi$19 = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractAlreadyRegistered",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractERC165SupportInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractInterfaceInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "subdomain",
                type: "string",
            },
        ],
        name: "InvalidDaoSubdomain",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "subdomain",
                type: "string",
            },
        ],
        name: "DAORegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "REGISTER_DAO_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_REGISTRY_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "entries",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_managingDao",
                type: "address",
            },
            {
                internalType: "contract ENSSubdomainRegistrar",
                name: "_subdomainRegistrar",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                internalType: "string",
                name: "subdomain",
                type: "string",
            },
        ],
        name: "register",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "subdomainRegistrar",
        outputs: [
            {
                internalType: "contract ENSSubdomainRegistrar",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "targetInterfaceId",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$X = "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";
const isSuperArgs$X = (xs) => xs.length > 1;
class DAORegistry__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$X(args)) {
            super(...args);
        }
        else {
            super(_abi$19, _bytecode$X, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$19);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$19, signerOrProvider);
    }
}
DAORegistry__factory.bytecode = _bytecode$X;
DAORegistry__factory.abi = _abi$19;

/* Autogenerated file. Do not edit manually. */

var index$H = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DAOFactory__factory: DAOFactory__factory,
  DAORegistry__factory: DAORegistry__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$18 = [
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_release",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_pluginSetupAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_buildMetadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_releaseMetadata",
                type: "bytes",
            },
        ],
        name: "createVersion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_release",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "_releaseMetadata",
                type: "bytes",
            },
        ],
        name: "updateReleaseMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IPluginRepo__factory {
    static createInterface() {
        return new utils.Interface(_abi$18);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$18, signerOrProvider);
    }
}
IPluginRepo__factory.abi = _abi$18;

/* Autogenerated file. Do not edit manually. */
const _abi$17 = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AnyAddressDisallowedForWhoAndWhere",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionInterfacNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionNotAContract",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyReleaseMetadata",
        type: "error",
    },
    {
        inputs: [],
        name: "GrantWithConditionNotSupported",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidPluginSetupInterface",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "latestRelease",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "newRelease",
                type: "uint8",
            },
        ],
        name: "InvalidReleaseIncrement",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "currentCondition",
                type: "address",
            },
            {
                internalType: "address",
                name: "newCondition",
                type: "address",
            },
        ],
        name: "PermissionAlreadyGrantedForDifferentCondition",
        type: "error",
    },
    {
        inputs: [],
        name: "PermissionsForAnyAddressDisallowed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "release",
                type: "uint8",
            },
            {
                internalType: "uint16",
                name: "build",
                type: "uint16",
            },
            {
                internalType: "address",
                name: "pluginSetup",
                type: "address",
            },
        ],
        name: "PluginSetupAlreadyInPreviousRelease",
        type: "error",
    },
    {
        inputs: [],
        name: "ReleaseDoesNotExist",
        type: "error",
    },
    {
        inputs: [],
        name: "ReleaseZeroNotAllowed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "Unauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "versionHash",
                type: "bytes32",
            },
        ],
        name: "VersionHashDoesNotExist",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "condition",
                type: "address",
            },
        ],
        name: "Granted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "release",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "releaseMetadata",
                type: "bytes",
            },
        ],
        name: "ReleaseMetadataUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
        ],
        name: "Revoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "release",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "build",
                type: "uint16",
            },
            {
                indexed: true,
                internalType: "address",
                name: "pluginSetup",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "buildMetadata",
                type: "bytes",
            },
        ],
        name: "VersionCreated",
        type: "event",
    },
    {
        inputs: [],
        name: "MAINTAINER_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ROOT_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_REPO_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "_items",
                type: "tuple[]",
            },
        ],
        name: "applyMultiTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.SingleTargetPermission[]",
                name: "items",
                type: "tuple[]",
            },
        ],
        name: "applySingleTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_release",
                type: "uint8",
            },
        ],
        name: "buildCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_release",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_pluginSetup",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_buildMetadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_releaseMetadata",
                type: "bytes",
            },
        ],
        name: "createVersion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_pluginSetup",
                type: "address",
            },
        ],
        name: "getLatestVersion",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "release",
                                type: "uint8",
                            },
                            {
                                internalType: "uint16",
                                name: "build",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct PluginRepo.Tag",
                        name: "tag",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "pluginSetup",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "buildMetadata",
                        type: "bytes",
                    },
                ],
                internalType: "struct PluginRepo.Version",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_release",
                type: "uint8",
            },
        ],
        name: "getLatestVersion",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "release",
                                type: "uint8",
                            },
                            {
                                internalType: "uint16",
                                name: "build",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct PluginRepo.Tag",
                        name: "tag",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "pluginSetup",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "buildMetadata",
                        type: "bytes",
                    },
                ],
                internalType: "struct PluginRepo.Version",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_tagHash",
                type: "bytes32",
            },
        ],
        name: "getVersion",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "release",
                                type: "uint8",
                            },
                            {
                                internalType: "uint16",
                                name: "build",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct PluginRepo.Tag",
                        name: "tag",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "pluginSetup",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "buildMetadata",
                        type: "bytes",
                    },
                ],
                internalType: "struct PluginRepo.Version",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "release",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "build",
                        type: "uint16",
                    },
                ],
                internalType: "struct PluginRepo.Tag",
                name: "_tag",
                type: "tuple",
            },
        ],
        name: "getVersion",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "release",
                                type: "uint8",
                            },
                            {
                                internalType: "uint16",
                                name: "build",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct PluginRepo.Tag",
                        name: "tag",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "pluginSetup",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "buildMetadata",
                        type: "bytes",
                    },
                ],
                internalType: "struct PluginRepo.Version",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "grant",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "contract IPermissionCondition",
                name: "_condition",
                type: "address",
            },
        ],
        name: "grantWithCondition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestRelease",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolVersion",
        outputs: [
            {
                internalType: "uint8[3]",
                name: "",
                type: "uint8[3]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "revoke",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_release",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "_releaseMetadata",
                type: "bytes",
            },
        ],
        name: "updateReleaseMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$W = "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";
const isSuperArgs$W = (xs) => xs.length > 1;
class PluginRepo__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$W(args)) {
            super(...args);
        }
        else {
            super(_abi$17, _bytecode$W, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$17);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$17, signerOrProvider);
    }
}
PluginRepo__factory.bytecode = _bytecode$W;
PluginRepo__factory.abi = _abi$17;

/* Autogenerated file. Do not edit manually. */
const _abi$16 = [
    {
        inputs: [
            {
                internalType: "contract PluginRepoRegistry",
                name: "_pluginRepoRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_subdomain",
                type: "string",
            },
            {
                internalType: "address",
                name: "_initialOwner",
                type: "address",
            },
        ],
        name: "createPluginRepo",
        outputs: [
            {
                internalType: "contract PluginRepo",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_subdomain",
                type: "string",
            },
            {
                internalType: "address",
                name: "_pluginSetup",
                type: "address",
            },
            {
                internalType: "address",
                name: "_maintainer",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_releaseMetadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_buildMetadata",
                type: "bytes",
            },
        ],
        name: "createPluginRepoWithFirstVersion",
        outputs: [
            {
                internalType: "contract PluginRepo",
                name: "pluginRepo",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginRepoBase",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginRepoRegistry",
        outputs: [
            {
                internalType: "contract PluginRepoRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolVersion",
        outputs: [
            {
                internalType: "uint8[3]",
                name: "",
                type: "uint8[3]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$V = "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";
const isSuperArgs$V = (xs) => xs.length > 1;
class PluginRepoFactory__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$V(args)) {
            super(...args);
        }
        else {
            super(_abi$16, _bytecode$V, args[0]);
        }
    }
    deploy(_pluginRepoRegistry, overrides) {
        return super.deploy(_pluginRepoRegistry, overrides || {});
    }
    getDeployTransaction(_pluginRepoRegistry, overrides) {
        return super.getDeployTransaction(_pluginRepoRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$16);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$16, signerOrProvider);
    }
}
PluginRepoFactory__factory.bytecode = _bytecode$V;
PluginRepoFactory__factory.abi = _abi$16;

/* Autogenerated file. Do not edit manually. */
const _abi$15 = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractAlreadyRegistered",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractERC165SupportInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractInterfaceInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyPluginRepoSubdomain",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "subdomain",
                type: "string",
            },
        ],
        name: "InvalidPluginSubdomain",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "subdomain",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "pluginRepo",
                type: "address",
            },
        ],
        name: "PluginRepoRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "REGISTER_PLUGIN_REPO_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_REGISTRY_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "entries",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "contract ENSSubdomainRegistrar",
                name: "_subdomainRegistrar",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "subdomain",
                type: "string",
            },
            {
                internalType: "address",
                name: "pluginRepo",
                type: "address",
            },
        ],
        name: "registerPluginRepo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "subdomainRegistrar",
        outputs: [
            {
                internalType: "contract ENSSubdomainRegistrar",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "targetInterfaceId",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$U = "0x60a06040523060805234801561001457600080fd5b5061001d610022565b6100e2565b600054610100900460ff161561008e5760405162461bcd60e51b815260206004820152602760248201527f496e697469616c697a61626c653a20636f6e747261637420697320696e697469604482015266616c697a696e6760c81b606482015260840160405180910390fd5b60005460ff90811610156100e0576000805460ff191660ff9081179091556040519081527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b565b608051611718610119600039600081816102b00152818161034b015281816105c001528181610656015261075101526117186000f3fe6080604052600436106100bb5760003560e01c80634f1ef28611610074578063ce091c861161004e578063ce091c8614610212578063f29ee12514610246578063fdb9df551461028657600080fd5b80634f1ef286146101a857806352d1902d146101bb57806374574eb7146101de57600080fd5b80634162169f116100a55780634162169f1461011f57806344162ef81461013d578063485cc9551461018857600080fd5b8062077393146100c05780633659cfe6146100fd575b600080fd5b3480156100cc57600080fd5b5060fb546100e0906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b34801561010957600080fd5b5061011d610118366004611347565b6102a6565b005b34801561012b57600080fd5b506097546001600160a01b03166100e0565b34801561014957600080fd5b5060c9546101579060e01b81565b6040517fffffffff0000000000000000000000000000000000000000000000000000000090911681526020016100f4565b34801561019457600080fd5b5061011d6101a3366004611364565b610448565b61011d6101b63660046113b3565b6105b6565b3480156101c757600080fd5b506101d0610744565b6040519081526020016100f4565b3480156101ea57600080fd5b506101d07f60b96ff9fb5f29153c29c1747515b8be4ee523d686cc6f453ec294b0afa7293281565b34801561021e57600080fd5b506101d07f055973dfb6d3b3cd890dde3a801f5427fa973864752b6d2a1ae61cbd5ae5dc0981565b34801561025257600080fd5b50610276610261366004611347565b60ca6020526000908152604090205460ff1681565b60405190151581526020016100f4565b34801561029257600080fd5b5061011d6102a1366004611477565b610809565b6001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036103495760405162461bcd60e51b815260206004820152602c60248201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060448201527f64656c656761746563616c6c000000000000000000000000000000000000000060648201526084015b60405180910390fd5b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166103a47f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc546001600160a01b031690565b6001600160a01b0316146104205760405162461bcd60e51b815260206004820152602c60248201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060448201527f6163746976652070726f787900000000000000000000000000000000000000006064820152608401610340565b610429816109a5565b60408051600080825260208201909252610445918391906109de565b50565b600054610100900460ff16158080156104685750600054600160ff909116105b806104825750303b158015610482575060005460ff166001145b6104f45760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a65640000000000000000000000000000000000006064820152608401610340565b6000805460ff191660011790558015610517576000805461ff0019166101001790555b7fd4321b40000000000000000000000000000000000000000000000000000000006105428482610b7e565b5060fb805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b03841617905580156105b1576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b505050565b6001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001630036106545760405162461bcd60e51b815260206004820152602c60248201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060448201527f64656c656761746563616c6c00000000000000000000000000000000000000006064820152608401610340565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166106af7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc546001600160a01b031690565b6001600160a01b03161461072b5760405162461bcd60e51b815260206004820152602c60248201527f46756e6374696f6e206d7573742062652063616c6c6564207468726f7567682060448201527f6163746976652070726f787900000000000000000000000000000000000000006064820152608401610340565b610734826109a5565b610740828260016109de565b5050565b6000306001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146107e45760405162461bcd60e51b815260206004820152603860248201527f555550535570677261646561626c653a206d757374206e6f742062652063616c60448201527f6c6564207468726f7567682064656c656761746563616c6c00000000000000006064820152608401610340565b507f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc90565b6097547f055973dfb6d3b3cd890dde3a801f5427fa973864752b6d2a1ae61cbd5ae5dc0990610847906001600160a01b031630335b84600036610c39565b8261087e576040517feb59207700000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6108888484610d27565b6108c25783836040517f5b7dee83000000000000000000000000000000000000000000000000000000008152600401610340929190611525565b600084846040516108d4929190611541565b60405190819003812060fb547f89bb4145000000000000000000000000000000000000000000000000000000008352600483018290526001600160a01b03868116602485015291935016906389bb414590604401600060405180830381600087803b15801561094257600080fd5b505af1158015610956573d6000803e3d6000fd5b5050505061096383610dd4565b7f8cc06643d6cbee78b006d2df2db4d2487b69dd64bb2c96088280fb29dd93a0b285858560405161099693929190611551565b60405180910390a15050505050565b6097547f60b96ff9fb5f29153c29c1747515b8be4ee523d686cc6f453ec294b0afa7293290610740906001600160a01b0316303361083e565b7f4910fdfa16fed3260ed0e7147f7cc6da11a60208b5b9406d12a635614ffd91435460ff1615610a11576105b183610eb1565b826001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015610a6b575060408051601f3d908101601f19168201909252610a689181019061157e565b60015b610add5760405162461bcd60e51b815260206004820152602e60248201527f45524331393637557067726164653a206e657720696d706c656d656e7461746960448201527f6f6e206973206e6f7420555550530000000000000000000000000000000000006064820152608401610340565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc8114610b725760405162461bcd60e51b815260206004820152602960248201527f45524331393637557067726164653a20756e737570706f727465642070726f7860448201527f6961626c655555494400000000000000000000000000000000000000000000006064820152608401610340565b506105b1838383610f7c565b600054610100900460ff16610bfb5760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201527f6e697469616c697a696e670000000000000000000000000000000000000000006064820152608401610340565b610c0482610fa7565b60c980547fffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000001660e09290921c91909117905550565b6040517ffdef91060000000000000000000000000000000000000000000000000000000081526001600160a01b0387169063fdef910690610c869088908890889088908890600401611597565b602060405180830381865afa158015610ca3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cc791906115ca565b610d1f576040517f32dbe3b40000000000000000000000000000000000000000000000000000000081526001600160a01b03808816600483015280871660248301528516604482015260648101849052608401610340565b505050505050565b6000828280835b81811015610dc5576000848483818110610d4a57610d4a6115ec565b919091013560f81c915050606081118015610d685750607b8160ff16105b15610d735750610db3565b602f8160ff16118015610d895750603a8160ff16105b15610d945750610db3565b8060ff16602d03610da55750610db3565b600095505050505050610dce565b80610dbd81611602565b915050610d2e565b50600193505050505b92915050565b6001600160a01b038116600090815260ca602052604090205460ff1615610e32576040517ffdcce17f0000000000000000000000000000000000000000000000000000000081526001600160a01b0382166004820152602401610340565b60c954610e4c906001600160a01b0383169060e01b611053565b610e8d576040517f71023c8a0000000000000000000000000000000000000000000000000000000081526001600160a01b0382166004820152602401610340565b6001600160a01b0316600090815260ca60205260409020805460ff19166001179055565b6001600160a01b0381163b610f2e5760405162461bcd60e51b815260206004820152602d60248201527f455243313936373a206e657720696d706c656d656e746174696f6e206973206e60448201527f6f74206120636f6e7472616374000000000000000000000000000000000000006064820152608401610340565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b0392909216919091179055565b610f8583611076565b600082511180610f925750805b156105b157610fa183836110b6565b50505050565b600054610100900460ff166110245760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201527f6e697469616c697a696e670000000000000000000000000000000000000000006064820152608401610340565b6097805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b0392909216919091179055565b600061105e836111c1565b801561106f575061106f8383611225565b9392505050565b61107f81610eb1565b6040516001600160a01b038216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b60606001600160a01b0383163b6111355760405162461bcd60e51b815260206004820152602660248201527f416464726573733a2064656c65676174652063616c6c20746f206e6f6e2d636f60448201527f6e747261637400000000000000000000000000000000000000000000000000006064820152608401610340565b600080846001600160a01b031684604051611150919061166c565b600060405180830381855af49150503d806000811461118b576040519150601f19603f3d011682016040523d82523d6000602084013e611190565b606091505b50915091506111b882826040518060600160405280602781526020016116bc602791396112f4565b95945050505050565b60006111ed827f01ffc9a700000000000000000000000000000000000000000000000000000000611225565b8015610dce575061121e827fffffffff00000000000000000000000000000000000000000000000000000000611225565b1592915050565b604080517fffffffff000000000000000000000000000000000000000000000000000000008316602480830191909152825180830390910181526044909101909152602080820180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff167f01ffc9a700000000000000000000000000000000000000000000000000000000178152825160009392849283928392918391908a617530fa92503d915060005190508280156112dd575060208210155b80156112e95750600081115b979650505050505050565b6060831561130357508161106f565b61106f83838151156113185781518083602001fd5b8060405162461bcd60e51b81526004016103409190611688565b6001600160a01b038116811461044557600080fd5b60006020828403121561135957600080fd5b813561106f81611332565b6000806040838503121561137757600080fd5b823561138281611332565b9150602083013561139281611332565b809150509250929050565b634e487b7160e01b600052604160045260246000fd5b600080604083850312156113c657600080fd5b82356113d181611332565b9150602083013567ffffffffffffffff808211156113ee57600080fd5b818501915085601f83011261140257600080fd5b8135818111156114145761141461139d565b604051601f8201601f19908116603f0116810190838211818310171561143c5761143c61139d565b8160405282815288602084870101111561145557600080fd5b8260208601602083013760006020848301015280955050505050509250929050565b60008060006040848603121561148c57600080fd5b833567ffffffffffffffff808211156114a457600080fd5b818601915086601f8301126114b857600080fd5b8135818111156114c757600080fd5b8760208285010111156114d957600080fd5b602092830195509350508401356114ef81611332565b809150509250925092565b818352818160208501375060006020828401015260006020601f19601f840116840101905092915050565b6020815260006115396020830184866114fa565b949350505050565b8183823760009101908152919050565b6040815260006115656040830185876114fa565b90506001600160a01b0383166020830152949350505050565b60006020828403121561159057600080fd5b5051919050565b60006001600160a01b038088168352808716602084015250846040830152608060608301526112e96080830184866114fa565b6000602082840312156115dc57600080fd5b8151801515811461106f57600080fd5b634e487b7160e01b600052603260045260246000fd5b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff820361164157634e487b7160e01b600052601160045260246000fd5b5060010190565b60005b8381101561166357818101518382015260200161164b565b50506000910152565b6000825161167e818460208701611648565b9190910192915050565b60208152600082518060208401526116a7816040850160208701611648565b601f01601f1916919091016040019291505056fe416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c6564a26469706673582212203d1e0e96a2975a4b191d30a66b44e6258624469413d2d82e03388055bcaf062664736f6c63430008110033";
const isSuperArgs$U = (xs) => xs.length > 1;
class PluginRepoRegistry__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$U(args)) {
            super(...args);
        }
        else {
            super(_abi$15, _bytecode$U, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$15);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$15, signerOrProvider);
    }
}
PluginRepoRegistry__factory.bytecode = _bytecode$U;
PluginRepoRegistry__factory.abi = _abi$15;

/* Autogenerated file. Do not edit manually. */

var index$G = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IPluginRepo__factory: IPluginRepo__factory,
  PluginRepo__factory: PluginRepo__factory,
  PluginRepoFactory__factory: PluginRepoFactory__factory,
  PluginRepoRegistry__factory: PluginRepoRegistry__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$14 = [
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IPluginSetup__factory {
    static createInterface() {
        return new utils.Interface(_abi$14);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$14, signerOrProvider);
    }
}
IPluginSetup__factory.abi = _abi$14;

/* Autogenerated file. Do not edit manually. */
const _abi$13 = [
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class PluginSetup__factory {
    static createInterface() {
        return new utils.Interface(_abi$13);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$13, signerOrProvider);
    }
}
PluginSetup__factory.abi = _abi$13;

/* Autogenerated file. Do not edit manually. */
const _abi$12 = [
    {
        inputs: [
            {
                internalType: "contract PluginRepoRegistry",
                name: "_repoRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
        ],
        name: "IPluginNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "currentAppliedSetupId",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "appliedSetupId",
                type: "bytes32",
            },
        ],
        name: "InvalidAppliedSetupId",
        type: "error",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "release",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "build",
                        type: "uint16",
                    },
                ],
                internalType: "struct PluginRepo.Tag",
                name: "currentVersionTag",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "release",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "build",
                        type: "uint16",
                    },
                ],
                internalType: "struct PluginRepo.Tag",
                name: "newVersionTag",
                type: "tuple",
            },
        ],
        name: "InvalidUpdateVersion",
        type: "error",
    },
    {
        inputs: [],
        name: "PluginAlreadyInstalled",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
        ],
        name: "PluginNonupgradeable",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
        ],
        name: "PluginProxyUpgradeFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "PluginRepoNonexistent",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
        ],
        name: "SetupAlreadyPrepared",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "SetupApplicationUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
        ],
        name: "SetupNotApplicable",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "appliedSetupId",
                type: "bytes32",
            },
        ],
        name: "InstallationApplied",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "contract PluginRepo",
                name: "pluginSetupRepo",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "release",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "build",
                        type: "uint16",
                    },
                ],
                indexed: false,
                internalType: "struct PluginRepo.Tag",
                name: "versionTag",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                indexed: false,
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        name: "InstallationPrepared",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
        ],
        name: "UninstallationApplied",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "contract PluginRepo",
                name: "pluginSetupRepo",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "release",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "build",
                        type: "uint16",
                    },
                ],
                indexed: false,
                internalType: "struct PluginRepo.Tag",
                name: "versionTag",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IPluginSetup.SetupPayload",
                name: "setupPayload",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                indexed: false,
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        name: "UninstallationPrepared",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "appliedSetupId",
                type: "bytes32",
            },
        ],
        name: "UpdateApplied",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "contract PluginRepo",
                name: "pluginSetupRepo",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "release",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "build",
                        type: "uint16",
                    },
                ],
                indexed: false,
                internalType: "struct PluginRepo.Tag",
                name: "versionTag",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IPluginSetup.SetupPayload",
                name: "setupPayload",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                indexed: false,
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
        ],
        name: "UpdatePrepared",
        type: "event",
    },
    {
        inputs: [],
        name: "APPLY_INSTALLATION_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "APPLY_UNINSTALLATION_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "APPLY_UPDATE_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "release",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint16",
                                        name: "build",
                                        type: "uint16",
                                    },
                                ],
                                internalType: "struct PluginRepo.Tag",
                                name: "versionTag",
                                type: "tuple",
                            },
                            {
                                internalType: "contract PluginRepo",
                                name: "pluginSetupRepo",
                                type: "address",
                            },
                        ],
                        internalType: "struct PluginSetupRef",
                        name: "pluginSetupRef",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "helpersHash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PluginSetupProcessor.ApplyInstallationParams",
                name: "_params",
                type: "tuple",
            },
        ],
        name: "applyInstallation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "release",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint16",
                                        name: "build",
                                        type: "uint16",
                                    },
                                ],
                                internalType: "struct PluginRepo.Tag",
                                name: "versionTag",
                                type: "tuple",
                            },
                            {
                                internalType: "contract PluginRepo",
                                name: "pluginSetupRepo",
                                type: "address",
                            },
                        ],
                        internalType: "struct PluginSetupRef",
                        name: "pluginSetupRef",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct PluginSetupProcessor.ApplyUninstallationParams",
                name: "_params",
                type: "tuple",
            },
        ],
        name: "applyUninstallation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "release",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint16",
                                        name: "build",
                                        type: "uint16",
                                    },
                                ],
                                internalType: "struct PluginRepo.Tag",
                                name: "versionTag",
                                type: "tuple",
                            },
                            {
                                internalType: "contract PluginRepo",
                                name: "pluginSetupRepo",
                                type: "address",
                            },
                        ],
                        internalType: "struct PluginSetupRef",
                        name: "pluginSetupRef",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "initData",
                        type: "bytes",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "helpersHash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PluginSetupProcessor.ApplyUpdateParams",
                name: "_params",
                type: "tuple",
            },
        ],
        name: "applyUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "release",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint16",
                                        name: "build",
                                        type: "uint16",
                                    },
                                ],
                                internalType: "struct PluginRepo.Tag",
                                name: "versionTag",
                                type: "tuple",
                            },
                            {
                                internalType: "contract PluginRepo",
                                name: "pluginSetupRepo",
                                type: "address",
                            },
                        ],
                        internalType: "struct PluginSetupRef",
                        name: "pluginSetupRef",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct PluginSetupProcessor.PrepareInstallationParams",
                name: "_params",
                type: "tuple",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "release",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint16",
                                        name: "build",
                                        type: "uint16",
                                    },
                                ],
                                internalType: "struct PluginRepo.Tag",
                                name: "versionTag",
                                type: "tuple",
                            },
                            {
                                internalType: "contract PluginRepo",
                                name: "pluginSetupRepo",
                                type: "address",
                            },
                        ],
                        internalType: "struct PluginSetupRef",
                        name: "pluginSetupRef",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "plugin",
                                type: "address",
                            },
                            {
                                internalType: "address[]",
                                name: "currentHelpers",
                                type: "address[]",
                            },
                            {
                                internalType: "bytes",
                                name: "data",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct IPluginSetup.SetupPayload",
                        name: "setupPayload",
                        type: "tuple",
                    },
                ],
                internalType: "struct PluginSetupProcessor.PrepareUninstallationParams",
                name: "_params",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "release",
                                type: "uint8",
                            },
                            {
                                internalType: "uint16",
                                name: "build",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct PluginRepo.Tag",
                        name: "currentVersionTag",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "release",
                                type: "uint8",
                            },
                            {
                                internalType: "uint16",
                                name: "build",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct PluginRepo.Tag",
                        name: "newVersionTag",
                        type: "tuple",
                    },
                    {
                        internalType: "contract PluginRepo",
                        name: "pluginSetupRepo",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "plugin",
                                type: "address",
                            },
                            {
                                internalType: "address[]",
                                name: "currentHelpers",
                                type: "address[]",
                            },
                            {
                                internalType: "bytes",
                                name: "data",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct IPluginSetup.SetupPayload",
                        name: "setupPayload",
                        type: "tuple",
                    },
                ],
                internalType: "struct PluginSetupProcessor.PrepareUpdateParams",
                name: "_params",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "repoRegistry",
        outputs: [
            {
                internalType: "contract PluginRepoRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "states",
        outputs: [
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "currentAppliedSetupId",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "pluginInstallationId",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "preparedSetupId",
                type: "bytes32",
            },
        ],
        name: "validatePreparedSetupId",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$T = "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";
const isSuperArgs$T = (xs) => xs.length > 1;
class PluginSetupProcessor__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$T(args)) {
            super(...args);
        }
        else {
            super(_abi$12, _bytecode$T, args[0]);
        }
    }
    deploy(_repoRegistry, overrides) {
        return super.deploy(_repoRegistry, overrides || {});
    }
    getDeployTransaction(_repoRegistry, overrides) {
        return super.getDeployTransaction(_repoRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$12);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$12, signerOrProvider);
    }
}
PluginSetupProcessor__factory.bytecode = _bytecode$T;
PluginSetupProcessor__factory.abi = _abi$12;

/* Autogenerated file. Do not edit manually. */

var index$F = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IPluginSetup__factory: IPluginSetup__factory,
  PluginSetup__factory: PluginSetup__factory,
  PluginSetupProcessor__factory: PluginSetupProcessor__factory
});

/* Autogenerated file. Do not edit manually. */

var index$E = /*#__PURE__*/Object.freeze({
  __proto__: null,
  repo: index$G,
  setup: index$F
});

/* Autogenerated file. Do not edit manually. */
const _abi$11 = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "subnode",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "nodeOwner",
                type: "address",
            },
        ],
        name: "AlreadyRegistered",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "node",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "resolver",
                type: "address",
            },
        ],
        name: "InvalidResolver",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "REGISTER_ENS_SUBDOMAIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_REGISTRAR_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ens",
        outputs: [
            {
                internalType: "contract ENS",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_managingDao",
                type: "address",
            },
            {
                internalType: "contract ENS",
                name: "_ens",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_node",
                type: "bytes32",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "node",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_label",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_targetAddress",
                type: "address",
            },
        ],
        name: "registerSubnode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "resolver",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_resolver",
                type: "address",
            },
        ],
        name: "setDefaultResolver",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$S = "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";
const isSuperArgs$S = (xs) => xs.length > 1;
class ENSSubdomainRegistrar__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$S(args)) {
            super(...args);
        }
        else {
            super(_abi$11, _bytecode$S, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$11);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$11, signerOrProvider);
    }
}
ENSSubdomainRegistrar__factory.bytecode = _bytecode$S;
ENSSubdomainRegistrar__factory.abi = _abi$11;

/* Autogenerated file. Do not edit manually. */

var index$D = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ENSSubdomainRegistrar__factory: ENSSubdomainRegistrar__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$10 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractAlreadyRegistered",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractERC165SupportInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractInterfaceInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_REGISTRY_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "entries",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "targetInterfaceId",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
class InterfaceBasedRegistry__factory {
    static createInterface() {
        return new utils.Interface(_abi$10);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$10, signerOrProvider);
    }
}
InterfaceBasedRegistry__factory.abi = _abi$10;

/* Autogenerated file. Do not edit manually. */
const _abi$$ = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "TokenNotERC20",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IERC20Upgradeable",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract MerkleMinter",
                name: "minter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract IMerkleDistributor",
                name: "distributor",
                type: "address",
            },
        ],
        name: "TokenCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract GovernanceWrappedERC20",
                name: "token",
                type: "address",
            },
        ],
        name: "WrappedToken",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract DAO",
                name: "_managingDao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "addr",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "symbol",
                        type: "string",
                    },
                ],
                internalType: "struct TokenFactory.TokenConfig",
                name: "_tokenConfig",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "receivers",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "amounts",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct GovernanceERC20.MintSettings",
                name: "_mintSettings",
                type: "tuple",
            },
        ],
        name: "createToken",
        outputs: [
            {
                internalType: "contract ERC20VotesUpgradeable",
                name: "",
                type: "address",
            },
            {
                internalType: "contract MerkleMinter",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "distributorBase",
        outputs: [
            {
                internalType: "contract MerkleDistributor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceERC20Base",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceWrappedERC20Base",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleMinterBase",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$R = "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";
const isSuperArgs$R = (xs) => xs.length > 1;
class TokenFactory__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$R(args)) {
            super(...args);
        }
        else {
            super(_abi$$, _bytecode$R, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$$);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$$, signerOrProvider);
    }
}
TokenFactory__factory.bytecode = _bytecode$R;
TokenFactory__factory.abi = _abi$$;

/* Autogenerated file. Do not edit manually. */

var index$C = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ens: index$D,
  InterfaceBasedRegistry__factory: InterfaceBasedRegistry__factory,
  TokenFactory__factory: TokenFactory__factory
});

/* Autogenerated file. Do not edit manually. */

var index$B = /*#__PURE__*/Object.freeze({
  __proto__: null,
  dao: index$H,
  plugin: index$E,
  utils: index$C
});

/* Autogenerated file. Do not edit manually. */
const _abi$_ = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "MULTIPLY_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "count",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "contract MultiplyHelper",
                name: "_multiplyHelper",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_count",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_a",
                type: "uint256",
            },
        ],
        name: "multiply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "multiplyHelper",
        outputs: [
            {
                internalType: "contract MultiplyHelper",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$Q = "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";
const isSuperArgs$Q = (xs) => xs.length > 1;
class CounterV1__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$Q(args)) {
            super(...args);
        }
        else {
            super(_abi$_, _bytecode$Q, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$_);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$_, signerOrProvider);
    }
}
CounterV1__factory.bytecode = _bytecode$Q;
CounterV1__factory.abi = _abi$_;

/* Autogenerated file. Do not edit manually. */
const _abi$Z = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "counterBase",
        outputs: [
            {
                internalType: "contract CounterV1",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "multiplyHelperBase",
        outputs: [
            {
                internalType: "contract MultiplyHelper",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$P = "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";
const isSuperArgs$P = (xs) => xs.length > 1;
class CounterV1PluginSetup__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$P(args)) {
            super(...args);
        }
        else {
            super(_abi$Z, _bytecode$P, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$Z);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$Z, signerOrProvider);
    }
}
CounterV1PluginSetup__factory.bytecode = _bytecode$P;
CounterV1PluginSetup__factory.abi = _abi$Z;

/* Autogenerated file. Do not edit manually. */

var index$A = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CounterV1__factory: CounterV1__factory,
  CounterV1PluginSetup__factory: CounterV1PluginSetup__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$Y = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "MULTIPLY_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "count",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "contract MultiplyHelper",
                name: "_multiplyHelper",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_count",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_newVariable",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_a",
                type: "uint256",
            },
        ],
        name: "multiply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "multiplyHelper",
        outputs: [
            {
                internalType: "contract MultiplyHelper",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "newVariable",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_newVariable",
                type: "uint256",
            },
        ],
        name: "setNewVariable",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$O = "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";
const isSuperArgs$O = (xs) => xs.length > 1;
class CounterV2__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$O(args)) {
            super(...args);
        }
        else {
            super(_abi$Y, _bytecode$O, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$Y);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$Y, signerOrProvider);
    }
}
CounterV2__factory.bytecode = _bytecode$O;
CounterV2__factory.abi = _abi$Y;

/* Autogenerated file. Do not edit manually. */
const _abi$X = [
    {
        inputs: [
            {
                internalType: "contract MultiplyHelper",
                name: "_helper",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "counterBase",
        outputs: [
            {
                internalType: "contract CounterV2",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "multiplyHelperBase",
        outputs: [
            {
                internalType: "contract MultiplyHelper",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$N = "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";
const isSuperArgs$N = (xs) => xs.length > 1;
class CounterV2PluginSetup__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$N(args)) {
            super(...args);
        }
        else {
            super(_abi$X, _bytecode$N, args[0]);
        }
    }
    deploy(_helper, overrides) {
        return super.deploy(_helper, overrides || {});
    }
    getDeployTransaction(_helper, overrides) {
        return super.getDeployTransaction(_helper, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$X);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$X, signerOrProvider);
    }
}
CounterV2PluginSetup__factory.bytecode = _bytecode$N;
CounterV2PluginSetup__factory.abi = _abi$X;

/* Autogenerated file. Do not edit manually. */

var index$z = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CounterV2__factory: CounterV2__factory,
  CounterV2PluginSetup__factory: CounterV2PluginSetup__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$W = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "MULTIPLY_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_b",
                type: "uint256",
            },
        ],
        name: "multiply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$M = "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";
const isSuperArgs$M = (xs) => xs.length > 1;
class MultiplyHelper__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$M(args)) {
            super(...args);
        }
        else {
            super(_abi$W, _bytecode$M, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$W);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$W, signerOrProvider);
    }
}
MultiplyHelper__factory.bytecode = _bytecode$M;
MultiplyHelper__factory.abi = _abi$W;

/* Autogenerated file. Do not edit manually. */

var index$y = /*#__PURE__*/Object.freeze({
  __proto__: null,
  v1: index$A,
  v2: index$z,
  MultiplyHelper__factory: MultiplyHelper__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$V = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "definingContract",
                type: "address",
            },
        ],
        name: "MembershipContractAnnounced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        inputs: [],
        name: "EXECUTE_PROPOSAL_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "_allowFailureMap",
                type: "uint256",
            },
        ],
        name: "executeProposal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isMember",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$L = "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";
const isSuperArgs$L = (xs) => xs.length > 1;
class Admin__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$L(args)) {
            super(...args);
        }
        else {
            super(_abi$V, _bytecode$L, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$V);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$V, signerOrProvider);
    }
}
Admin__factory.bytecode = _bytecode$L;
Admin__factory.abi = _abi$V;

/* Autogenerated file. Do not edit manually. */
const _abi$U = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "AdminAddressInvalid",
        type: "error",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$K = "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";
const isSuperArgs$K = (xs) => xs.length > 1;
class AdminSetup__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$K(args)) {
            super(...args);
        }
        else {
            super(_abi$U, _bytecode$K, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$U);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$U, signerOrProvider);
    }
}
AdminSetup__factory.bytecode = _bytecode$K;
AdminSetup__factory.abi = _abi$U;

/* Autogenerated file. Do not edit manually. */

var index$x = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Admin__factory: Admin__factory,
  AdminSetup__factory: AdminSetup__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$T = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "DateOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "member",
                type: "address",
            },
        ],
        name: "InvalidAddresslistUpdate",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "MinDurationOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ProposalCreationForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecutionForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "limit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "RatioOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
        ],
        name: "VoteCastForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "definingContract",
                type: "address",
            },
        ],
        name: "MembershipContractAnnounced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votingPower",
                type: "uint256",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "enum MajorityVotingBase.VotingMode",
                name: "votingMode",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "supportThreshold",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "minParticipation",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "minDuration",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minProposerVotingPower",
                type: "uint256",
            },
        ],
        name: "VotingSettingsUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "UPDATE_ADDRESSES_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPDATE_VOTING_SETTINGS_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_members",
                type: "address[]",
            },
        ],
        name: "addAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "addresslistLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "addresslistLengthAtBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "canExecute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_voter",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
        ],
        name: "canVote",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "_allowFailureMap",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "_startDate",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "_endDate",
                type: "uint64",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "_tryEarlyExecution",
                type: "bool",
            },
        ],
        name: "createProposal",
        outputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "getProposal",
        outputs: [
            {
                internalType: "bool",
                name: "open",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "startDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "endDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "snapshotBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.ProposalParameters",
                name: "parameters",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "abstain",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "yes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "no",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.Tally",
                name: "tally",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_voter",
                type: "address",
            },
        ],
        name: "getVoteOption",
        outputs: [
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minParticipation",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "minDuration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minProposerVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.VotingSettings",
                name: "_votingSettings",
                type: "tuple",
            },
            {
                internalType: "address[]",
                name: "_members",
                type: "address[]",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isListed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "isListedAtBlock",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isMember",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isMinParticipationReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReachedEarly",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minDuration",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minParticipation",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minProposerVotingPower",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_members",
                type: "address[]",
            },
        ],
        name: "removeAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "supportThreshold",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "totalVotingPower",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minParticipation",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "minDuration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minProposerVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.VotingSettings",
                name: "_votingSettings",
                type: "tuple",
            },
        ],
        name: "updateVotingSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "_tryEarlyExecution",
                type: "bool",
            },
        ],
        name: "vote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "votingMode",
        outputs: [
            {
                internalType: "enum MajorityVotingBase.VotingMode",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$J = "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";
const isSuperArgs$J = (xs) => xs.length > 1;
class AddresslistVoting__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$J(args)) {
            super(...args);
        }
        else {
            super(_abi$T, _bytecode$J, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$T);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$T, signerOrProvider);
    }
}
AddresslistVoting__factory.bytecode = _bytecode$J;
AddresslistVoting__factory.abi = _abi$T;

/* Autogenerated file. Do not edit manually. */
const _abi$S = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$I = "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";
const isSuperArgs$I = (xs) => xs.length > 1;
class AddresslistVotingSetup__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$I(args)) {
            super(...args);
        }
        else {
            super(_abi$S, _bytecode$I, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$S);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$S, signerOrProvider);
    }
}
AddresslistVotingSetup__factory.bytecode = _bytecode$I;
AddresslistVotingSetup__factory.abi = _abi$S;

/* Autogenerated file. Do not edit manually. */

var index$w = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AddresslistVoting__factory: AddresslistVoting__factory,
  AddresslistVotingSetup__factory: AddresslistVotingSetup__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$R = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "DateOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "MinDurationOutOfBounds",
        type: "error",
    },
    {
        inputs: [],
        name: "NoVotingPower",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ProposalCreationForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecutionForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "limit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "RatioOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
        ],
        name: "VoteCastForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "definingContract",
                type: "address",
            },
        ],
        name: "MembershipContractAnnounced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votingPower",
                type: "uint256",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "enum MajorityVotingBase.VotingMode",
                name: "votingMode",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "supportThreshold",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "minParticipation",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "minDuration",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minProposerVotingPower",
                type: "uint256",
            },
        ],
        name: "VotingSettingsUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "UPDATE_VOTING_SETTINGS_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "canExecute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_voter",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
        ],
        name: "canVote",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "_allowFailureMap",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "_startDate",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "_endDate",
                type: "uint64",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "_tryEarlyExecution",
                type: "bool",
            },
        ],
        name: "createProposal",
        outputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "getProposal",
        outputs: [
            {
                internalType: "bool",
                name: "open",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "startDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "endDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "snapshotBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.ProposalParameters",
                name: "parameters",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "abstain",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "yes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "no",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.Tally",
                name: "tally",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_voter",
                type: "address",
            },
        ],
        name: "getVoteOption",
        outputs: [
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getVotingToken",
        outputs: [
            {
                internalType: "contract IVotesUpgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minParticipation",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "minDuration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minProposerVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.VotingSettings",
                name: "_votingSettings",
                type: "tuple",
            },
            {
                internalType: "contract IVotesUpgradeable",
                name: "_token",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isMember",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isMinParticipationReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReachedEarly",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minDuration",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minParticipation",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minProposerVotingPower",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "supportThreshold",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "totalVotingPower",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minParticipation",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "minDuration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minProposerVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.VotingSettings",
                name: "_votingSettings",
                type: "tuple",
            },
        ],
        name: "updateVotingSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "_tryEarlyExecution",
                type: "bool",
            },
        ],
        name: "vote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "votingMode",
        outputs: [
            {
                internalType: "enum MajorityVotingBase.VotingMode",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$H = "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";
const isSuperArgs$H = (xs) => xs.length > 1;
class TokenVoting__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$H(args)) {
            super(...args);
        }
        else {
            super(_abi$R, _bytecode$H, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$R);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$R, signerOrProvider);
    }
}
TokenVoting__factory.bytecode = _bytecode$H;
TokenVoting__factory.abi = _abi$R;

/* Autogenerated file. Do not edit manually. */
const _abi$Q = [
    {
        inputs: [
            {
                internalType: "contract GovernanceERC20",
                name: "_governanceERC20Base",
                type: "address",
            },
            {
                internalType: "contract GovernanceWrappedERC20",
                name: "_governanceWrappedERC20Base",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenNotContract",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenNotERC20",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "length",
                type: "uint256",
            },
        ],
        name: "WrongHelpersArrayLength",
        type: "error",
    },
    {
        inputs: [],
        name: "governanceERC20Base",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceWrappedERC20Base",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$G = "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";
const isSuperArgs$G = (xs) => xs.length > 1;
class TokenVotingSetup__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$G(args)) {
            super(...args);
        }
        else {
            super(_abi$Q, _bytecode$G, args[0]);
        }
    }
    deploy(_governanceERC20Base, _governanceWrappedERC20Base, overrides) {
        return super.deploy(_governanceERC20Base, _governanceWrappedERC20Base, overrides || {});
    }
    getDeployTransaction(_governanceERC20Base, _governanceWrappedERC20Base, overrides) {
        return super.getDeployTransaction(_governanceERC20Base, _governanceWrappedERC20Base, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$Q);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$Q, signerOrProvider);
    }
}
TokenVotingSetup__factory.bytecode = _bytecode$G;
TokenVotingSetup__factory.abi = _abi$Q;

/* Autogenerated file. Do not edit manually. */

var index$v = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TokenVoting__factory: TokenVoting__factory,
  TokenVotingSetup__factory: TokenVotingSetup__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$P = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votingPower",
                type: "uint256",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "canExecute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
        ],
        name: "canVote",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "getVoteOption",
        outputs: [
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isMinParticipationReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReachedEarly",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minParticipation",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "supportThreshold",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "_tryEarlyExecution",
                type: "bool",
            },
        ],
        name: "vote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IMajorityVoting__factory {
    static createInterface() {
        return new utils.Interface(_abi$P);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$P, signerOrProvider);
    }
}
IMajorityVoting__factory.abi = _abi$P;

/* Autogenerated file. Do not edit manually. */
const _abi$O = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "DateOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "MinDurationOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ProposalCreationForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecutionForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "limit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "RatioOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
        ],
        name: "VoteCastForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votingPower",
                type: "uint256",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "enum MajorityVotingBase.VotingMode",
                name: "votingMode",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "supportThreshold",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "minParticipation",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "minDuration",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minProposerVotingPower",
                type: "uint256",
            },
        ],
        name: "VotingSettingsUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "UPDATE_VOTING_SETTINGS_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "canExecute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_voter",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
        ],
        name: "canVote",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "_allowFailureMap",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "_startDate",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "_endDate",
                type: "uint64",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "_tryEarlyExecution",
                type: "bool",
            },
        ],
        name: "createProposal",
        outputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "getProposal",
        outputs: [
            {
                internalType: "bool",
                name: "open",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "startDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "endDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "snapshotBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.ProposalParameters",
                name: "parameters",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "abstain",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "yes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "no",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.Tally",
                name: "tally",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_voter",
                type: "address",
            },
        ],
        name: "getVoteOption",
        outputs: [
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isMinParticipationReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReachedEarly",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minDuration",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minParticipation",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minProposerVotingPower",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "supportThreshold",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "totalVotingPower",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minParticipation",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "minDuration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minProposerVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.VotingSettings",
                name: "_votingSettings",
                type: "tuple",
            },
        ],
        name: "updateVotingSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "_tryEarlyExecution",
                type: "bool",
            },
        ],
        name: "vote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "votingMode",
        outputs: [
            {
                internalType: "enum MajorityVotingBase.VotingMode",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class MajorityVotingBase__factory {
    static createInterface() {
        return new utils.Interface(_abi$O);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$O, signerOrProvider);
    }
}
MajorityVotingBase__factory.abi = _abi$O;

/* Autogenerated file. Do not edit manually. */

var index$u = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addresslist: index$w,
  token: index$v,
  IMajorityVoting__factory: IMajorityVoting__factory,
  MajorityVotingBase__factory: MajorityVotingBase__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$N = [
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_members",
                type: "address[]",
            },
        ],
        name: "addAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_tryExecution",
                type: "bool",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "canApprove",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "canExecute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "hasApproved",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_members",
                type: "address[]",
            },
        ],
        name: "removeAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IMultisig__factory {
    static createInterface() {
        return new utils.Interface(_abi$N);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$N, signerOrProvider);
    }
}
IMultisig__factory.abi = _abi$N;

/* Autogenerated file. Do not edit manually. */
const _abi$M = [
    {
        inputs: [
            {
                internalType: "uint16",
                name: "limit",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "AddresslistLengthOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ApprovalCastForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "DateOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "member",
                type: "address",
            },
        ],
        name: "InvalidAddresslistUpdate",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "limit",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "actual",
                type: "uint16",
            },
        ],
        name: "MinApprovalsOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ProposalCreationForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecutionForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "Approved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[]",
                name: "members",
                type: "address[]",
            },
        ],
        name: "MembersRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "definingContract",
                type: "address",
            },
        ],
        name: "MembershipContractAnnounced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "onlyListed",
                type: "bool",
            },
            {
                indexed: true,
                internalType: "uint16",
                name: "minApprovals",
                type: "uint16",
            },
        ],
        name: "MultisigSettingsUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPDATE_MULTISIG_SETTINGS_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_members",
                type: "address[]",
            },
        ],
        name: "addAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "addresslistLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "addresslistLengthAtBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_tryExecution",
                type: "bool",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "canApprove",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "canExecute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "_allowFailureMap",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_approveProposal",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "_tryExecution",
                type: "bool",
            },
            {
                internalType: "uint64",
                name: "_startDate",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "_endDate",
                type: "uint64",
            },
        ],
        name: "createProposal",
        outputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "getProposal",
        outputs: [
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
            {
                internalType: "uint16",
                name: "approvals",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "minApprovals",
                        type: "uint16",
                    },
                    {
                        internalType: "uint64",
                        name: "snapshotBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "startDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "endDate",
                        type: "uint64",
                    },
                ],
                internalType: "struct Multisig.ProposalParameters",
                name: "parameters",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "hasApproved",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_members",
                type: "address[]",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "onlyListed",
                        type: "bool",
                    },
                    {
                        internalType: "uint16",
                        name: "minApprovals",
                        type: "uint16",
                    },
                ],
                internalType: "struct Multisig.MultisigSettings",
                name: "_multisigSettings",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isListed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "isListedAtBlock",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isMember",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastMultisigSettingsChange",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "multisigSettings",
        outputs: [
            {
                internalType: "bool",
                name: "onlyListed",
                type: "bool",
            },
            {
                internalType: "uint16",
                name: "minApprovals",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_members",
                type: "address[]",
            },
        ],
        name: "removeAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "onlyListed",
                        type: "bool",
                    },
                    {
                        internalType: "uint16",
                        name: "minApprovals",
                        type: "uint16",
                    },
                ],
                internalType: "struct Multisig.MultisigSettings",
                name: "_multisigSettings",
                type: "tuple",
            },
        ],
        name: "updateMultisigSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$F = "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";
const isSuperArgs$F = (xs) => xs.length > 1;
class Multisig__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$F(args)) {
            super(...args);
        }
        else {
            super(_abi$M, _bytecode$F, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$M);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$M, signerOrProvider);
    }
}
Multisig__factory.bytecode = _bytecode$F;
Multisig__factory.abi = _abi$M;

/* Autogenerated file. Do not edit manually. */
const _abi$L = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$E = "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";
const isSuperArgs$E = (xs) => xs.length > 1;
class MultisigSetup__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$E(args)) {
            super(...args);
        }
        else {
            super(_abi$L, _bytecode$E, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$L);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$L, signerOrProvider);
    }
}
MultisigSetup__factory.bytecode = _bytecode$E;
MultisigSetup__factory.abi = _abi$L;

/* Autogenerated file. Do not edit manually. */

var index$t = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IMultisig__factory: IMultisig__factory,
  Multisig__factory: Multisig__factory,
  MultisigSetup__factory: MultisigSetup__factory
});

/* Autogenerated file. Do not edit manually. */

var index$s = /*#__PURE__*/Object.freeze({
  __proto__: null,
  admin: index$x,
  majorityVoting: index$u,
  multisig: index$t
});

/* Autogenerated file. Do not edit manually. */
const _abi$K = [
    {
        inputs: [],
        name: "PlaceholderSetupCannotBeUsed",
        type: "error",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$D = "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";
const isSuperArgs$D = (xs) => xs.length > 1;
class PlaceholderSetup__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$D(args)) {
            super(...args);
        }
        else {
            super(_abi$K, _bytecode$D, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$K);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$K, signerOrProvider);
    }
}
PlaceholderSetup__factory.bytecode = _bytecode$D;
PlaceholderSetup__factory.abi = _abi$K;

/* Autogenerated file. Do not edit manually. */

var index$r = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PlaceholderSetup__factory: PlaceholderSetup__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$J = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "_proof",
                type: "bytes32[]",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "_proof",
                type: "bytes32[]",
            },
        ],
        name: "unclaimedBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IMerkleDistributor__factory {
    static createInterface() {
        return new utils.Interface(_abi$J);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$J, signerOrProvider);
    }
}
IMerkleDistributor__factory.abi = _abi$J;

/* Autogenerated file. Do not edit manually. */
const _abi$I = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "distributor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "tree",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "context",
                type: "bytes",
            },
        ],
        name: "MerkleMinted",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract IMerkleDistributor",
                name: "_distributorBase",
                type: "address",
            },
        ],
        name: "changeDistributorBase",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "distributorBase",
        outputs: [
            {
                internalType: "contract IMerkleDistributor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_totalAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_tree",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_context",
                type: "bytes",
            },
        ],
        name: "merkleMint",
        outputs: [
            {
                internalType: "contract IMerkleDistributor",
                name: "distributor",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "contract IERC20MintableUpgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IMerkleMinter__factory {
    static createInterface() {
        return new utils.Interface(_abi$I);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$I, signerOrProvider);
    }
}
IMerkleMinter__factory.abi = _abi$I;

/* Autogenerated file. Do not edit manually. */
const _abi$H = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "TokenAlreadyClaimed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenClaimInvalid",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "_proof",
                type: "bytes32[]",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "contract IERC20Upgradeable",
                name: "_token",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_merkleRoot",
                type: "bytes32",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "_proof",
                type: "bytes32[]",
            },
        ],
        name: "unclaimedBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$C = "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";
const isSuperArgs$C = (xs) => xs.length > 1;
class MerkleDistributor__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$C(args)) {
            super(...args);
        }
        else {
            super(_abi$H, _bytecode$C, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$H);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$H, signerOrProvider);
    }
}
MerkleDistributor__factory.bytecode = _bytecode$C;
MerkleDistributor__factory.abi = _abi$H;

/* Autogenerated file. Do not edit manually. */
const _abi$G = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "distributor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "merkleRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "tree",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "context",
                type: "bytes",
            },
        ],
        name: "MerkleMinted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "CHANGE_DISTRIBUTOR_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MERKLE_MINT_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IMerkleDistributor",
                name: "_distributorBase",
                type: "address",
            },
        ],
        name: "changeDistributorBase",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "distributorBase",
        outputs: [
            {
                internalType: "contract IMerkleDistributor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "contract IERC20MintableUpgradeable",
                name: "_token",
                type: "address",
            },
            {
                internalType: "contract IMerkleDistributor",
                name: "_distributorBase",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_totalAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_tree",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_context",
                type: "bytes",
            },
        ],
        name: "merkleMint",
        outputs: [
            {
                internalType: "contract IMerkleDistributor",
                name: "distributor",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "contract IERC20MintableUpgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$B = "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";
const isSuperArgs$B = (xs) => xs.length > 1;
class MerkleMinter__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$B(args)) {
            super(...args);
        }
        else {
            super(_abi$G, _bytecode$B, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$G);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$G, signerOrProvider);
    }
}
MerkleMinter__factory.bytecode = _bytecode$B;
MerkleMinter__factory.abi = _abi$G;

/* Autogenerated file. Do not edit manually. */

var index$q = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IMerkleDistributor__factory: IMerkleDistributor__factory,
  IMerkleMinter__factory: IMerkleMinter__factory,
  MerkleDistributor__factory: MerkleDistributor__factory,
  MerkleMinter__factory: MerkleMinter__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$F = [
    {
        inputs: [
            {
                internalType: "address",
                name: "member",
                type: "address",
            },
        ],
        name: "InvalidAddresslistUpdate",
        type: "error",
    },
    {
        inputs: [],
        name: "addresslistLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "addresslistLengthAtBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isListed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "isListedAtBlock",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class Addresslist__factory {
    static createInterface() {
        return new utils.Interface(_abi$F);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$F, signerOrProvider);
    }
}
Addresslist__factory.abi = _abi$F;

/* Autogenerated file. Do not edit manually. */

var index$p = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Addresslist__factory: Addresslist__factory
});

/* Autogenerated file. Do not edit manually. */

var index$o = /*#__PURE__*/Object.freeze({
  __proto__: null,
  counterExample: index$y,
  governance: index$s,
  placeholderVersion: index$r,
  token: index$q,
  utils: index$p
});

/* Autogenerated file. Do not edit manually. */
const _abi$E = [
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "callbackSelector",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "magicNumber",
                type: "bytes4",
            },
        ],
        name: "UnkownCallback",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "bytes4",
                name: "sig",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "CallbackReceived",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "selector",
                type: "bytes4",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "handleCallback",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "selector",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "magicNumber",
                type: "bytes4",
            },
        ],
        name: "registerCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$A = "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";
const isSuperArgs$A = (xs) => xs.length > 1;
class CallbackHandlerMockHelper__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$A(args)) {
            super(...args);
        }
        else {
            super(_abi$E, _bytecode$A, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$E);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$E, signerOrProvider);
    }
}
CallbackHandlerMockHelper__factory.bytecode = _bytecode$A;
CallbackHandlerMockHelper__factory.abi = _abi$E;

/* Autogenerated file. Do not edit manually. */

var index$n = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CallbackHandlerMockHelper__factory: CallbackHandlerMockHelper__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$D = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "count",
                type: "uint256",
            },
        ],
        name: "consumeGas",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "store",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$z = "0x608060405234801561001057600080fd5b50610163806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c80636057361d1461003b578063a329e8de1461006d575b600080fd5b61005b6100493660046100b5565b60006020819052908152604090205481565b60405190815260200160405180910390f35b61008061007b3660046100b5565b610082565b005b60005b818110156100b157600081815260208190526040902060019055806100a9816100ce565b915050610085565b5050565b6000602082840312156100c757600080fd5b5035919050565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8203610126577f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b506001019056fea2646970667358221220a195996a4aea2ec0feac03e2c52dc6c8ac143c1812d679fe4d1fd2b3ad7d7b6d64736f6c63430008110033";
const isSuperArgs$z = (xs) => xs.length > 1;
class GasConsumer__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$z(args)) {
            super(...args);
        }
        else {
            super(_abi$D, _bytecode$z, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$D);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$D, signerOrProvider);
    }
}
GasConsumer__factory.bytecode = _bytecode$z;
GasConsumer__factory.abi = _abi$D;

/* Autogenerated file. Do not edit manually. */

var index$m = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GasConsumer__factory: GasConsumer__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$C = [
    {
        inputs: [],
        name: "fail",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newNum",
                type: "uint256",
            },
        ],
        name: "setTest",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$y = "0x6080604052600a60005534801561001557600080fd5b50610118806100256000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80636ca1f933146037578063a9cc471814605c575b600080fd5b604a604236600460ca565b600081905590565b60405190815260200160405180910390f35b60626064565b005b6040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601460248201527f416374696f6e457865637574653a526576657274000000000000000000000000604482015260640160405180910390fd5b60006020828403121560db57600080fd5b503591905056fea2646970667358221220ef30671210f4d6f984c46eec111d0de75e9566c0ff33c6afb60bf1899b1d4d9b64736f6c63430008110033";
const isSuperArgs$y = (xs) => xs.length > 1;
class ActionExecute__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$y(args)) {
            super(...args);
        }
        else {
            super(_abi$C, _bytecode$y, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$C);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$C, signerOrProvider);
    }
}
ActionExecute__factory.bytecode = _bytecode$y;
ActionExecute__factory.abi = _abi$C;

/* Autogenerated file. Do not edit manually. */
const _abi$B = [
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AnyAddressDisallowedForWhoAndWhere",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionInterfacNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionNotAContract",
        type: "error",
    },
    {
        inputs: [],
        name: "GrantWithConditionNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "currentCondition",
                type: "address",
            },
            {
                internalType: "address",
                name: "newCondition",
                type: "address",
            },
        ],
        name: "PermissionAlreadyGrantedForDifferentCondition",
        type: "error",
    },
    {
        inputs: [],
        name: "PermissionsForAnyAddressDisallowed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "Unauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "_reference",
                type: "string",
            },
        ],
        name: "Deposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "actor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "callId",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "failureMap",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "execResults",
                type: "bytes[]",
            },
        ],
        name: "Executed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "condition",
                type: "address",
            },
        ],
        name: "Granted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "MetadataSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "NativeTokenDeposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
        ],
        name: "Revoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "signatureValidator",
                type: "address",
            },
        ],
        name: "SignatureValidatorSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "callbackSelector",
                type: "bytes4",
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "magicNumber",
                type: "bytes4",
            },
        ],
        name: "StandardCallbackRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "forwarder",
                type: "address",
            },
        ],
        name: "TrustedForwarderSet",
        type: "event",
    },
    {
        inputs: [],
        name: "ROOT_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "_items",
                type: "tuple[]",
            },
        ],
        name: "applyMultiTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.SingleTargetPermission[]",
                name: "items",
                type: "tuple[]",
            },
        ],
        name: "applySingleTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "callId",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes[]",
                name: "execResults",
                type: "bytes[]",
            },
            {
                internalType: "uint256",
                name: "failureMap",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getTrustedForwarder",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "grant",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "contract IPermissionCondition",
                name: "_condition",
                type: "address",
            },
        ],
        name: "grantWithCondition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "hasPermission",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "pastVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "_callbackSelector",
                type: "bytes4",
            },
            {
                internalType: "bytes4",
                name: "_magicNumber",
                type: "bytes4",
            },
        ],
        name: "registerStandardCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "revoke",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "setMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "setSignatureValidator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "setTrustedForwarder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$x = "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";
const isSuperArgs$x = (xs) => xs.length > 1;
class DAOMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$x(args)) {
            super(...args);
        }
        else {
            super(_abi$B, _bytecode$x, args[0]);
        }
    }
    deploy(initialOwner, overrides) {
        return super.deploy(initialOwner, overrides || {});
    }
    getDeployTransaction(initialOwner, overrides) {
        return super.getDeployTransaction(initialOwner, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$B);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$B, signerOrProvider);
    }
}
DAOMock__factory.bytecode = _bytecode$x;
DAOMock__factory.abi = _abi$B;

/* Autogenerated file. Do not edit manually. */
const _abi$A = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode$w = "0x608060405234801561001057600080fd5b506101d8806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c80631626ba7e14610030575b600080fd5b61006561003e3660046100c9565b7f414243440000000000000000000000000000000000000000000000000000000092915050565b6040517fffffffff00000000000000000000000000000000000000000000000000000000909116815260200160405180910390f35b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b600080604083850312156100dc57600080fd5b82359150602083013567ffffffffffffffff808211156100fb57600080fd5b818501915085601f83011261010f57600080fd5b8135818111156101215761012161009a565b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0908116603f011681019083821181831017156101675761016761009a565b8160405282815288602084870101111561018057600080fd5b826020860160208301376000602084830101528095505050505050925092905056fea2646970667358221220d95519071cb111dd4f57a7d40d7ecd8368a4400e9919e8cd0887cfdf48bb0d1264736f6c63430008110033";
const isSuperArgs$w = (xs) => xs.length > 1;
class ERC1271Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$w(args)) {
            super(...args);
        }
        else {
            super(_abi$A, _bytecode$w, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$A);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$A, signerOrProvider);
    }
}
ERC1271Mock__factory.bytecode = _bytecode$w;
ERC1271Mock__factory.abi = _abi$A;

/* Autogenerated file. Do not edit manually. */

var index$l = /*#__PURE__*/Object.freeze({
  __proto__: null,
  callbackHandlerHelperMockSol: index$n,
  gasConsumerHelperSol: index$m,
  ActionExecute__factory: ActionExecute__factory,
  DAOMock__factory: DAOMock__factory,
  ERC1271Mock__factory: ERC1271Mock__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$z = [
    {
        inputs: [],
        name: "ADD_PERMISSIONED_SELECTOR",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "getSelector",
        outputs: [
            {
                internalType: "bytes4",
                name: "sig",
                type: "bytes4",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$v = "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";
const isSuperArgs$v = (xs) => xs.length > 1;
class TestParameterScopingPermissionCondition__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$v(args)) {
            super(...args);
        }
        else {
            super(_abi$z, _bytecode$v, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$z);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$z, signerOrProvider);
    }
}
TestParameterScopingPermissionCondition__factory.bytecode = _bytecode$v;
TestParameterScopingPermissionCondition__factory.abi = _abi$z;

/* Autogenerated file. Do not edit manually. */

var index$k = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TestParameterScopingPermissionCondition__factory: TestParameterScopingPermissionCondition__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$y = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_result",
                type: "bool",
            },
        ],
        name: "setWillPerform",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$u = "0x60806040526000805460ff1916600117905534801561001d57600080fd5b506103568061002d6000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c806301ffc9a7146100465780632675fdd01461006d578063e209399114610089575b600080fd5b610059610054366004610163565b6100ca565b604051901515815260200160405180910390f35b61005961007b366004610204565b60005460ff16949350505050565b6100c86100973660046102fe565b600080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0016911515919091179055565b005b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f2675fdd000000000000000000000000000000000000000000000000000000000148061015d57507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b92915050565b60006020828403121561017557600080fd5b81357fffffffff00000000000000000000000000000000000000000000000000000000811681146101a557600080fd5b9392505050565b803573ffffffffffffffffffffffffffffffffffffffff811681146101d057600080fd5b919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6000806000806080858703121561021a57600080fd5b610223856101ac565b9350610231602086016101ac565b925060408501359150606085013567ffffffffffffffff8082111561025557600080fd5b818701915087601f83011261026957600080fd5b81358181111561027b5761027b6101d5565b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0908116603f011681019083821181831017156102c1576102c16101d5565b816040528281528a60208487010111156102da57600080fd5b82602086016020830137600060208483010152809550505050505092959194509250565b60006020828403121561031057600080fd5b813580151581146101a557600080fdfea2646970667358221220484e4368eaae0824b00df80d2138fb8c6245cd8ace73636aed5a2c1083859ad464736f6c63430008110033";
const isSuperArgs$u = (xs) => xs.length > 1;
class PermissionConditionMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$u(args)) {
            super(...args);
        }
        else {
            super(_abi$y, _bytecode$u, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$y);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$y, signerOrProvider);
    }
}
PermissionConditionMock__factory.bytecode = _bytecode$u;
PermissionConditionMock__factory.abi = _abi$y;

/* Autogenerated file. Do not edit manually. */
const _abi$x = [
    {
        inputs: [],
        name: "AnyAddressDisallowedForWhoAndWhere",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionInterfacNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IPermissionCondition",
                name: "condition",
                type: "address",
            },
        ],
        name: "ConditionNotAContract",
        type: "error",
    },
    {
        inputs: [],
        name: "GrantWithConditionNotSupported",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "currentCondition",
                type: "address",
            },
            {
                internalType: "address",
                name: "newCondition",
                type: "address",
            },
        ],
        name: "PermissionAlreadyGrantedForDifferentCondition",
        type: "error",
    },
    {
        inputs: [],
        name: "PermissionsForAnyAddressDisallowed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "Unauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "condition",
                type: "address",
            },
        ],
        name: "Granted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "here",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "who",
                type: "address",
            },
        ],
        name: "Revoked",
        type: "event",
    },
    {
        inputs: [],
        name: "ROOT_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "TEST_PERMISSION_1_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "TEST_PERMISSION_2_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "_items",
                type: "tuple[]",
            },
        ],
        name: "applyMultiTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.SingleTargetPermission[]",
                name: "items",
                type: "tuple[]",
            },
        ],
        name: "applySingleTargetPermissions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAnyAddr",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "getAuthPermission",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "getPermissionHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "grant",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "contract IPermissionCondition",
                name: "_condition",
                type: "address",
            },
        ],
        name: "grantWithCondition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "hasPermission",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
        ],
        name: "revoke",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$t = "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";
const isSuperArgs$t = (xs) => xs.length > 1;
class PermissionManagerTest__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$t(args)) {
            super(...args);
        }
        else {
            super(_abi$x, _bytecode$t, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$x);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$x, signerOrProvider);
    }
}
PermissionManagerTest__factory.bytecode = _bytecode$t;
PermissionManagerTest__factory.abi = _abi$x;

/* Autogenerated file. Do not edit manually. */

var index$j = /*#__PURE__*/Object.freeze({
  __proto__: null,
  parameterScopingPermissionConditionTestSol: index$k,
  PermissionConditionMock__factory: PermissionConditionMock__factory,
  PermissionManagerTest__factory: PermissionManagerTest__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$w = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "state1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$s = "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";
const isSuperArgs$s = (xs) => xs.length > 1;
class PluginCloneableV1Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$s(args)) {
            super(...args);
        }
        else {
            super(_abi$w, _bytecode$s, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$w);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$w, signerOrProvider);
    }
}
PluginCloneableV1Mock__factory.bytecode = _bytecode$s;
PluginCloneableV1Mock__factory.abi = _abi$w;

/* Autogenerated file. Do not edit manually. */
const _abi$v = [
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "state1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$r = "0x608060405234801561001057600080fd5b5060d78061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80636accab8c146037578063c4d66de8146051575b600080fd5b603f60005481565b60405190815260200160405180910390f35b6064605c3660046066565b506001600055565b005b600060208284031215607757600080fd5b813573ffffffffffffffffffffffffffffffffffffffff81168114609a57600080fd5b939250505056fea26469706673582212203df8c9f91f5816a3f884c42ac7c039b045efbf8f92dfc72cb810e03dd82c10aa64736f6c63430008110033";
const isSuperArgs$r = (xs) => xs.length > 1;
class PluginCloneableV1MockBad__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$r(args)) {
            super(...args);
        }
        else {
            super(_abi$v, _bytecode$r, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$v);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$v, signerOrProvider);
    }
}
PluginCloneableV1MockBad__factory.bytecode = _bytecode$r;
PluginCloneableV1MockBad__factory.abi = _abi$v;

/* Autogenerated file. Do not edit manually. */
const _abi$u = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "state1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state2",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$q = "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";
const isSuperArgs$q = (xs) => xs.length > 1;
class PluginCloneableV2Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$q(args)) {
            super(...args);
        }
        else {
            super(_abi$u, _bytecode$q, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$u);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$u, signerOrProvider);
    }
}
PluginCloneableV2Mock__factory.bytecode = _bytecode$q;
PluginCloneableV2Mock__factory.abi = _abi$u;

/* Autogenerated file. Do not edit manually. */

var index$i = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PluginCloneableV1Mock__factory: PluginCloneableV1Mock__factory,
  PluginCloneableV1MockBad__factory: PluginCloneableV1MockBad__factory,
  PluginCloneableV2Mock__factory: PluginCloneableV2Mock__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$t = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$p = "0x608060405234801561001057600080fd5b5060405161001d9061005f565b604051809103906000f080158015610039573d6000803e3d6000fd5b50600080546001600160a01b0319166001600160a01b039290921691909117905561006c565b61060a806112eb83390190565b6112708061007b6000396000f3fe60806040523480156200001157600080fd5b50600436106200006f5760003560e01c80639cb0a12411620000565780639cb0a12414620000bc578063a8a9c29e14620000e2578063f10832f1146200010957600080fd5b806301ffc9a714620000745780635c60da1b14620000a0575b600080fd5b6200008b62000085366004620005c7565b62000130565b60405190151581526020015b60405180910390f35b6000546040516001600160a01b03909116815260200162000097565b620000d3620000cd3660046200063b565b620001ca565b6040516200009791906200070c565b620000f9620000f336600462000759565b620001e3565b60405162000097929190620008a8565b620001206200011a366004620008f0565b6200020b565b60405162000097929190620009be565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f99718b50000000000000000000000000000000000000000000000000000000001480620001c457507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b92915050565b6060620001dc60056006600162000271565b9392505050565b606062000203604051806040016040528060608152602001606081525090565b935093915050565b60006200022b604051806040016040528060608152602001606081525090565b60005462000243906001600160a01b03168562000413565b9150620002516001620004b9565b81526200026360056006600062000271565b602082015290939092509050565b6060836001600160a01b0316836001600160a01b0316116200029257600080fd5b6200029e848462000a00565b6001600160a01b031667ffffffffffffffff811115620002c257620002c2620008da565b6040519080825280602002602001820160405280156200033b57816020015b6040805160a0810182526000808252602080830182905292820181905260608201819052608082015282527fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff909201910181620002e15790505b509050835b836001600160a01b0316816001600160a01b031610156200040b576040518060a001604052808460028111156200037b576200037b6200068f565b81526001600160a01b038316602082018190526040820152600060608201527fa280eec51ab8e1bc4b6b0c1b7f1bde785761b787a49db404e3e9338ed9b016ef60809091015282620003ce878462000a00565b6001600160a01b031681518110620003ea57620003ea62000a2a565b60200260200101819052508080620004029062000a40565b91505062000340565b509392505050565b6040516001600160a01b0382166024820152600090620001dc9084907fc4d66de8473e8f74cb05df264ee8262da16b56717ef1f05d73bfdcea3adc85e59060440160408051601f198184030181529190526020810180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff167fffffffff00000000000000000000000000000000000000000000000000000000909316929092179091526200057d565b6060816001600160a01b031667ffffffffffffffff811115620004e057620004e0620008da565b6040519080825280602002602001820160405280156200050a578160200160208202803683370190505b50905060005b826001600160a01b0316816001600160a01b0316101562000577578082826001600160a01b0316815181106200054a576200054a62000a2a565b6001600160a01b0390921660209283029190910190910152806200056e8162000a40565b91505062000510565b50919050565b600082826040516200058f90620005b9565b6200059c92919062000a69565b604051809103906000f0801580156200040b573d6000803e3d6000fd5b6107ad8062000a8e83390190565b600060208284031215620005da57600080fd5b81357fffffffff0000000000000000000000000000000000000000000000000000000081168114620001dc57600080fd5b80356001600160a01b03811681146200062357600080fd5b919050565b6000606082840312156200057757600080fd5b600080604083850312156200064f57600080fd5b6200065a836200060b565b9150602083013567ffffffffffffffff8111156200067757600080fd5b620006858582860162000628565b9150509250929050565b634e487b7160e01b600052602160045260246000fd5b6000815160038110620006c857634e487b7160e01b600052602160045260246000fd5b8352506020818101516001600160a01b0390811691840191909152604080830151821690840152606080830151909116908301526080908101519082015260a00190565b6020808252825182820181905260009190848201906040850190845b818110156200074d576200073e838551620006a5565b93850193925060010162000728565b50909695505050505050565b6000806000606084860312156200076f57600080fd5b6200077a846200060b565b9250602084013561ffff811681146200079257600080fd5b9150604084013567ffffffffffffffff811115620007af57600080fd5b620007bd8682870162000628565b9150509250925092565b6000815180845260005b81811015620007ef57602081850181015186830182015201620007d1565b506000602082860101526020601f19601f83011685010191505092915050565b805160408084528151908401819052600091602091908201906060860190845b81811015620008565783516001600160a01b0316835292840192918401916001016200082f565b50508483015186820387850152805180835290840192506000918401905b808310156200089d576200088a828551620006a5565b9150848401935060018301925062000874565b509695505050505050565b604081526000620008bd6040830185620007c7565b8281036020840152620008d181856200080f565b95945050505050565b634e487b7160e01b600052604160045260246000fd5b600080604083850312156200090457600080fd5b6200090f836200060b565b9150602083013567ffffffffffffffff808211156200092d57600080fd5b818501915085601f8301126200094257600080fd5b813581811115620009575762000957620008da565b604051601f8201601f19908116603f01168101908382118183101715620009825762000982620008da565b816040528281528860208487010111156200099c57600080fd5b8260208601602083013760006020848301015280955050505050509250929050565b6001600160a01b0383168152604060208201526000620009e260408301846200080f565b949350505050565b634e487b7160e01b600052601160045260246000fd5b6001600160a01b0382811682821603908082111562000a235762000a23620009ea565b5092915050565b634e487b7160e01b600052603260045260246000fd5b60006001600160a01b0380831681810362000a5f5762000a5f620009ea565b6001019392505050565b6001600160a01b0383168152604060208201526000620009e26040830184620007c756fe60806040526040516107ad3803806107ad83398101604081905261002291610319565b61002e82826000610035565b5050610436565b61003e8361006b565b60008251118061004b5750805b156100665761006483836100ab60201b6100291760201c565b505b505050565b610074816100d7565b6040516001600160a01b038216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b60606100d08383604051806060016040528060278152602001610786602791396101a9565b9392505050565b6100ea8161022260201b6100551760201c565b6101515760405162461bcd60e51b815260206004820152602d60248201527f455243313936373a206e657720696d706c656d656e746174696f6e206973206e60448201526c1bdd08184818dbdb9d1c9858dd609a1b60648201526084015b60405180910390fd5b806101887f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc60001b61023160201b6100711760201c565b80546001600160a01b0319166001600160a01b039290921691909117905550565b6060600080856001600160a01b0316856040516101c691906103e7565b600060405180830381855af49150503d8060008114610201576040519150601f19603f3d011682016040523d82523d6000602084013e610206565b606091505b50909250905061021886838387610234565b9695505050505050565b6001600160a01b03163b151590565b90565b606083156102a357825160000361029c576001600160a01b0385163b61029c5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e74726163740000006044820152606401610148565b50816102ad565b6102ad83836102b5565b949350505050565b8151156102c55781518083602001fd5b8060405162461bcd60e51b81526004016101489190610403565b634e487b7160e01b600052604160045260246000fd5b60005b838110156103105781810151838201526020016102f8565b50506000910152565b6000806040838503121561032c57600080fd5b82516001600160a01b038116811461034357600080fd5b60208401519092506001600160401b038082111561036057600080fd5b818501915085601f83011261037457600080fd5b815181811115610386576103866102df565b604051601f8201601f19908116603f011681019083821181831017156103ae576103ae6102df565b816040528281528860208487010111156103c757600080fd5b6103d88360208301602088016102f5565b80955050505050509250929050565b600082516103f98184602087016102f5565b9190910192915050565b60208152600082518060208401526104228160408501602087016102f5565b601f01601f19169190910160400192915050565b610341806104456000396000f3fe60806040523661001357610011610017565b005b6100115b610027610022610074565b6100b9565b565b606061004e83836040518060600160405280602781526020016102e5602791396100dd565b9392505050565b73ffffffffffffffffffffffffffffffffffffffff163b151590565b90565b60006100b47f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc5473ffffffffffffffffffffffffffffffffffffffff1690565b905090565b3660008037600080366000845af43d6000803e8080156100d8573d6000f35b3d6000fd5b60606000808573ffffffffffffffffffffffffffffffffffffffff16856040516101079190610277565b600060405180830381855af49150503d8060008114610142576040519150601f19603f3d011682016040523d82523d6000602084013e610147565b606091505b509150915061015886838387610162565b9695505050505050565b606083156101fd5782516000036101f65773ffffffffffffffffffffffffffffffffffffffff85163b6101f6576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e747261637400000060448201526064015b60405180910390fd5b5081610207565b610207838361020f565b949350505050565b81511561021f5781518083602001fd5b806040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016101ed9190610293565b60005b8381101561026e578181015183820152602001610256565b50506000910152565b60008251610289818460208701610253565b9190910192915050565b60208152600082518060208401526102b2816040850160208701610253565b601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe016919091016040019291505056fe416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c6564a2646970667358221220a7c6f2fcb78c7b4c40d8fd8b3b79a2770d3af4a9e7da56689bfa5ce2c1ce5a2164736f6c63430008110033416464726573733a206c6f772d6c6576656c2064656c65676174652063616c6c206661696c6564a2646970667358221220d5b4833d92afb5a65bbe36ecb2532db45686e6f32c1d352d2c28b7ad0054b8b964736f6c63430008110033608060405234801561001057600080fd5b5061001961001e565b6100de565b600054610100900460ff161561008a5760405162461bcd60e51b815260206004820152602760248201527f496e697469616c697a61626c653a20636f6e747261637420697320696e697469604482015266616c697a696e6760c81b606482015260840160405180910390fd5b60005460ff90811610156100dc576000805460ff191660ff9081179091556040519081527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b565b61051d806100ed6000396000f3fe608060405234801561001057600080fd5b50600436106100675760003560e01c806341de68301161005057806341de6830146100bc5780636accab8c146100cb578063c4d66de8146100e257600080fd5b806301ffc9a71461006c5780634162169f14610094575b600080fd5b61007f61007a366004610427565b6100f7565b60405190151581526020015b60405180910390f35b60655460405173ffffffffffffffffffffffffffffffffffffffff909116815260200161008b565b600160405161008b9190610470565b6100d460975481565b60405190815260200161008b565b6100f56100f03660046104b1565b610190565b005b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f41de683000000000000000000000000000000000000000000000000000000000148061018a57507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b92915050565b600054610100900460ff16158080156101b05750600054600160ff909116105b806101ca5750303b1580156101ca575060005460ff166001145b6102415760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a656400000000000000000000000000000000000060648201526084015b60405180910390fd5b600080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001660011790558015610282576000805461ff0019166101001790555b61028b826102da565b600160975580156102d6576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b5050565b600054610100900460ff166103575760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201527f6e697469616c697a696e670000000000000000000000000000000000000000006064820152608401610238565b61036081610363565b50565b600054610100900460ff166103e05760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201527f6e697469616c697a696e670000000000000000000000000000000000000000006064820152608401610238565b606580547fffffffffffffffffffffffff00000000000000000000000000000000000000001673ffffffffffffffffffffffffffffffffffffffff92909216919091179055565b60006020828403121561043957600080fd5b81357fffffffff000000000000000000000000000000000000000000000000000000008116811461046957600080fd5b9392505050565b60208101600383106104ab577f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b91905290565b6000602082840312156104c357600080fd5b813573ffffffffffffffffffffffffffffffffffffffff8116811461046957600080fdfea26469706673582212209fdbf7bb552ac2167aeda5748cca70681d5b51278371e2610369af45fcafb0af64736f6c63430008110033";
const isSuperArgs$p = (xs) => xs.length > 1;
class PluginCloneableSetupV1Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$p(args)) {
            super(...args);
        }
        else {
            super(_abi$t, _bytecode$p, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$t);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$t, signerOrProvider);
    }
}
PluginCloneableSetupV1Mock__factory.bytecode = _bytecode$p;
PluginCloneableSetupV1Mock__factory.abi = _abi$t;

/* Autogenerated file. Do not edit manually. */
const _abi$s = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$o = "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";
const isSuperArgs$o = (xs) => xs.length > 1;
class PluginCloneableSetupV1MockBad__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$o(args)) {
            super(...args);
        }
        else {
            super(_abi$s, _bytecode$o, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$s);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$s, signerOrProvider);
    }
}
PluginCloneableSetupV1MockBad__factory.bytecode = _bytecode$o;
PluginCloneableSetupV1MockBad__factory.abi = _abi$s;

/* Autogenerated file. Do not edit manually. */
const _abi$r = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$n = "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";
const isSuperArgs$n = (xs) => xs.length > 1;
class PluginCloneableSetupV2Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$n(args)) {
            super(...args);
        }
        else {
            super(_abi$r, _bytecode$n, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$r);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$r, signerOrProvider);
    }
}
PluginCloneableSetupV2Mock__factory.bytecode = _bytecode$n;
PluginCloneableSetupV2Mock__factory.abi = _abi$r;

/* Autogenerated file. Do not edit manually. */

var index$h = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PluginCloneableSetupV1Mock__factory: PluginCloneableSetupV1Mock__factory,
  PluginCloneableSetupV1MockBad__factory: PluginCloneableSetupV1MockBad__factory,
  PluginCloneableSetupV2Mock__factory: PluginCloneableSetupV2Mock__factory
});

/* Autogenerated file. Do not edit manually. */

var index$g = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pluginCloneableMockSol: index$i,
  pluginCloneableSetupMockSol: index$h
});

/* Autogenerated file. Do not edit manually. */
const _abi$q = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DO_SOMETHING_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_param1",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_param2",
                type: "uint256",
            },
        ],
        name: "addPermissioned",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "msgSender",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_param1",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_param2",
                type: "uint256",
            },
        ],
        name: "subPermissioned",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$m = "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";
const isSuperArgs$m = (xs) => xs.length > 1;
class TestPlugin__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$m(args)) {
            super(...args);
        }
        else {
            super(_abi$q, _bytecode$m, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$q);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$q, signerOrProvider);
    }
}
TestPlugin__factory.bytecode = _bytecode$m;
TestPlugin__factory.abi = _abi$q;

/* Autogenerated file. Do not edit manually. */

var index$f = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TestPlugin__factory: TestPlugin__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$p = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "allowedId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_where",
                type: "address",
            },
            {
                internalType: "address",
                name: "_who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_permissionId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "isGranted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$l = "0x608060405234801561001057600080fd5b5060405161034238038061034283398101604081905261002f91610037565b600055610050565b60006020828403121561004957600080fd5b5051919050565b6102e38061005f6000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c806301ffc9a7146100465780632675fdd01461006e5780637ffca28214610081575b600080fd5b61005961005436600461015d565b610098565b60405190151581526020015b60405180910390f35b61005961007c3660046101cf565b610131565b61008a60005481565b604051908152602001610065565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f2675fdd000000000000000000000000000000000000000000000000000000000148061012b57507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b92915050565b600080610141836004818761026a565b81019061014e9190610294565b60005414979650505050505050565b60006020828403121561016f57600080fd5b81357fffffffff000000000000000000000000000000000000000000000000000000008116811461019f57600080fd5b9392505050565b803573ffffffffffffffffffffffffffffffffffffffff811681146101ca57600080fd5b919050565b6000806000806000608086880312156101e757600080fd5b6101f0866101a6565b94506101fe602087016101a6565b935060408601359250606086013567ffffffffffffffff8082111561022257600080fd5b818801915088601f83011261023657600080fd5b81358181111561024557600080fd5b89602082850101111561025757600080fd5b9699959850939650602001949392505050565b6000808585111561027a57600080fd5b8386111561028757600080fd5b5050820193919092039150565b6000602082840312156102a657600080fd5b503591905056fea2646970667358221220af15c98c39bc14b88e5eb82916e25f33bdaa1dfa4602e0424d1f8a49e7a21bb564736f6c63430008110033";
const isSuperArgs$l = (xs) => xs.length > 1;
class TestIdGatingCondition__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$l(args)) {
            super(...args);
        }
        else {
            super(_abi$p, _bytecode$l, args[0]);
        }
    }
    deploy(_id, overrides) {
        return super.deploy(_id, overrides || {});
    }
    getDeployTransaction(_id, overrides) {
        return super.getDeployTransaction(_id, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$p);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$p, signerOrProvider);
    }
}
TestIdGatingCondition__factory.bytecode = _bytecode$l;
TestIdGatingCondition__factory.abi = _abi$p;

/* Autogenerated file. Do not edit manually. */
const _abi$o = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
        ],
        name: "ObjectIdNotAssigned",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "ID_GATED_ACTION_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "createNewObject",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
        ],
        name: "idGatedAction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "ownedIds",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$k = "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";
const isSuperArgs$k = (xs) => xs.length > 1;
class TestSharedPlugin__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$k(args)) {
            super(...args);
        }
        else {
            super(_abi$o, _bytecode$k, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$o);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$o, signerOrProvider);
    }
}
TestSharedPlugin__factory.bytecode = _bytecode$k;
TestSharedPlugin__factory.abi = _abi$o;

/* Autogenerated file. Do not edit manually. */

var index$e = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TestIdGatingCondition__factory: TestIdGatingCondition__factory,
  TestSharedPlugin__factory: TestSharedPlugin__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$n = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$j = "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";
const isSuperArgs$j = (xs) => xs.length > 1;
class PluginUUPSUpgradeableV1Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$j(args)) {
            super(...args);
        }
        else {
            super(_abi$n, _bytecode$j, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$n);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$n, signerOrProvider);
    }
}
PluginUUPSUpgradeableV1Mock__factory.bytecode = _bytecode$j;
PluginUUPSUpgradeableV1Mock__factory.abi = _abi$n;

/* Autogenerated file. Do not edit manually. */
const _abi$m = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initializeV1toV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state2",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$i = "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";
const isSuperArgs$i = (xs) => xs.length > 1;
class PluginUUPSUpgradeableV2Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$i(args)) {
            super(...args);
        }
        else {
            super(_abi$m, _bytecode$i, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$m);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$m, signerOrProvider);
    }
}
PluginUUPSUpgradeableV2Mock__factory.bytecode = _bytecode$i;
PluginUUPSUpgradeableV2Mock__factory.abi = _abi$m;

/* Autogenerated file. Do not edit manually. */
const _abi$l = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initializeV1toV3",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initializeV2toV3",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state2",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state3",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$h = "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";
const isSuperArgs$h = (xs) => xs.length > 1;
class PluginUUPSUpgradeableV3Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$h(args)) {
            super(...args);
        }
        else {
            super(_abi$l, _bytecode$h, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$l);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$l, signerOrProvider);
    }
}
PluginUUPSUpgradeableV3Mock__factory.bytecode = _bytecode$h;
PluginUUPSUpgradeableV3Mock__factory.abi = _abi$l;

/* Autogenerated file. Do not edit manually. */

var index$d = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PluginUUPSUpgradeableV1Mock__factory: PluginUUPSUpgradeableV1Mock__factory,
  PluginUUPSUpgradeableV2Mock__factory: PluginUUPSUpgradeableV2Mock__factory,
  PluginUUPSUpgradeableV3Mock__factory: PluginUUPSUpgradeableV3Mock__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$k = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$g = "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";
const isSuperArgs$g = (xs) => xs.length > 1;
class PluginUUPSUpgradeableSetupV1Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$g(args)) {
            super(...args);
        }
        else {
            super(_abi$k, _bytecode$g, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$k);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$k, signerOrProvider);
    }
}
PluginUUPSUpgradeableSetupV1Mock__factory.bytecode = _bytecode$g;
PluginUUPSUpgradeableSetupV1Mock__factory.abi = _abi$k;

/* Autogenerated file. Do not edit manually. */
const _abi$j = [
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$f = "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";
const isSuperArgs$f = (xs) => xs.length > 1;
class PluginUUPSUpgradeableSetupV1MockBad__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$f(args)) {
            super(...args);
        }
        else {
            super(_abi$j, _bytecode$f, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$j);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$j, signerOrProvider);
    }
}
PluginUUPSUpgradeableSetupV1MockBad__factory.bytecode = _bytecode$f;
PluginUUPSUpgradeableSetupV1MockBad__factory.abi = _abi$j;

/* Autogenerated file. Do not edit manually. */
const _abi$i = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$e = "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";
const isSuperArgs$e = (xs) => xs.length > 1;
class PluginUUPSUpgradeableSetupV2Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$e(args)) {
            super(...args);
        }
        else {
            super(_abi$i, _bytecode$e, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$i);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$i, signerOrProvider);
    }
}
PluginUUPSUpgradeableSetupV2Mock__factory.bytecode = _bytecode$e;
PluginUUPSUpgradeableSetupV2Mock__factory.abi = _abi$i;

/* Autogenerated file. Do not edit manually. */
const _abi$h = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$d = "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";
const isSuperArgs$d = (xs) => xs.length > 1;
class PluginUUPSUpgradeableSetupV3Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$d(args)) {
            super(...args);
        }
        else {
            super(_abi$h, _bytecode$d, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$h);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$h, signerOrProvider);
    }
}
PluginUUPSUpgradeableSetupV3Mock__factory.bytecode = _bytecode$d;
PluginUUPSUpgradeableSetupV3Mock__factory.abi = _abi$h;

/* Autogenerated file. Do not edit manually. */
const _abi$g = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_pluginUUPSUpgradeableV3",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "prepareInstallation",
        outputs: [
            {
                internalType: "address",
                name: "plugin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUninstallation",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum PermissionLib.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "where",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "who",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "condition",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "permissionId",
                        type: "bytes32",
                    },
                ],
                internalType: "struct PermissionLib.MultiTargetPermission[]",
                name: "permissions",
                type: "tuple[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "_currentBuild",
                type: "uint16",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "plugin",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "currentHelpers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IPluginSetup.SetupPayload",
                name: "_payload",
                type: "tuple",
            },
        ],
        name: "prepareUpdate",
        outputs: [
            {
                internalType: "bytes",
                name: "initData",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "helpers",
                        type: "address[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum PermissionLib.Operation",
                                name: "operation",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "where",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "who",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "condition",
                                type: "address",
                            },
                            {
                                internalType: "bytes32",
                                name: "permissionId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct PermissionLib.MultiTargetPermission[]",
                        name: "permissions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct IPluginSetup.PreparedSetupData",
                name: "preparedSetupData",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$c = "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";
const isSuperArgs$c = (xs) => xs.length > 1;
class PluginUUPSUpgradeableSetupV4Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$c(args)) {
            super(...args);
        }
        else {
            super(_abi$g, _bytecode$c, args[0]);
        }
    }
    deploy(_pluginUUPSUpgradeableV3, overrides) {
        return super.deploy(_pluginUUPSUpgradeableV3, overrides || {});
    }
    getDeployTransaction(_pluginUUPSUpgradeableV3, overrides) {
        return super.getDeployTransaction(_pluginUUPSUpgradeableV3, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$g);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$g, signerOrProvider);
    }
}
PluginUUPSUpgradeableSetupV4Mock__factory.bytecode = _bytecode$c;
PluginUUPSUpgradeableSetupV4Mock__factory.abi = _abi$g;

/* Autogenerated file. Do not edit manually. */

var index$c = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PluginUUPSUpgradeableSetupV1Mock__factory: PluginUUPSUpgradeableSetupV1Mock__factory,
  PluginUUPSUpgradeableSetupV1MockBad__factory: PluginUUPSUpgradeableSetupV1MockBad__factory,
  PluginUUPSUpgradeableSetupV2Mock__factory: PluginUUPSUpgradeableSetupV2Mock__factory,
  PluginUUPSUpgradeableSetupV3Mock__factory: PluginUUPSUpgradeableSetupV3Mock__factory,
  PluginUUPSUpgradeableSetupV4Mock__factory: PluginUUPSUpgradeableSetupV4Mock__factory
});

/* Autogenerated file. Do not edit manually. */

var index$b = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pluginUupsUpgradeableMockSol: index$d,
  pluginUupsUpgradeableSetupMockSol: index$c
});

/* Autogenerated file. Do not edit manually. */
const _abi$f = [
    {
        inputs: [
            {
                internalType: "address",
                name: "member",
                type: "address",
            },
        ],
        name: "InvalidAddresslistUpdate",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_newAddresses",
                type: "address[]",
            },
        ],
        name: "addAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "addresslistLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "addresslistLengthAtBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "isListed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
        ],
        name: "isListedAtBlock",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_exitingAddresses",
                type: "address[]",
            },
        ],
        name: "removeAddresses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$b = "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";
const isSuperArgs$b = (xs) => xs.length > 1;
class AddresslistMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$b(args)) {
            super(...args);
        }
        else {
            super(_abi$f, _bytecode$b, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$f);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$f, signerOrProvider);
    }
}
AddresslistMock__factory.bytecode = _bytecode$b;
AddresslistMock__factory.abi = _abi$f;

/* Autogenerated file. Do not edit manually. */
const _abi$e = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "deployClone",
        outputs: [
            {
                internalType: "address",
                name: "clone",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$a = "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";
const isSuperArgs$a = (xs) => xs.length > 1;
class AdminCloneFactory__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$a(args)) {
            super(...args);
        }
        else {
            super(_abi$e, _bytecode$a, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$e);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$e, signerOrProvider);
    }
}
AdminCloneFactory__factory.bytecode = _bytecode$a;
AdminCloneFactory__factory.abi = _abi$e;

/* Autogenerated file. Do not edit manually. */
const _abi$d = [
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "DateOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "limit",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "actual",
                type: "uint64",
            },
        ],
        name: "MinDurationOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ProposalCreationForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecutionForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "limit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "RatioOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
        ],
        name: "VoteCastForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "startDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "endDate",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum IMajorityVoting.VoteOption",
                name: "voteOption",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votingPower",
                type: "uint256",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "enum MajorityVotingBase.VotingMode",
                name: "votingMode",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "supportThreshold",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "minParticipation",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "minDuration",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "minProposerVotingPower",
                type: "uint256",
            },
        ],
        name: "VotingSettingsUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "UPDATE_VOTING_SETTINGS_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_PLUGIN_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "canExecute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_voter",
                type: "address",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
        ],
        name: "canVote",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        name: "createProposal",
        outputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "getProposal",
        outputs: [
            {
                internalType: "bool",
                name: "open",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "startDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "endDate",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "snapshotBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.ProposalParameters",
                name: "parameters",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "abstain",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "yes",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "no",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.Tally",
                name: "tally",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "to",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct IDAO.Action[]",
                name: "actions",
                type: "tuple[]",
            },
            {
                internalType: "uint256",
                name: "allowFailureMap",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_voter",
                type: "address",
            },
        ],
        name: "getVoteOption",
        outputs: [
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minParticipation",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "minDuration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minProposerVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.VotingSettings",
                name: "_votingSettings",
                type: "tuple",
            },
        ],
        name: "initializeMock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isMinParticipationReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReached",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
        ],
        name: "isSupportThresholdReachedEarly",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minDuration",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minParticipation",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minProposerVotingPower",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pluginType",
        outputs: [
            {
                internalType: "enum IPlugin.PluginType",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "supportThreshold",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "totalVotingPower",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum MajorityVotingBase.VotingMode",
                        name: "votingMode",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "supportThreshold",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "minParticipation",
                        type: "uint32",
                    },
                    {
                        internalType: "uint64",
                        name: "minDuration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "minProposerVotingPower",
                        type: "uint256",
                    },
                ],
                internalType: "struct MajorityVotingBase.VotingSettings",
                name: "_votingSettings",
                type: "tuple",
            },
        ],
        name: "updateVotingSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_proposalId",
                type: "uint256",
            },
            {
                internalType: "enum IMajorityVoting.VoteOption",
                name: "_voteOption",
                type: "uint8",
            },
            {
                internalType: "bool",
                name: "_tryEarlyExecution",
                type: "bool",
            },
        ],
        name: "vote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "votingMode",
        outputs: [
            {
                internalType: "enum MajorityVotingBase.VotingMode",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$9 = "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";
const isSuperArgs$9 = (xs) => xs.length > 1;
class MajorityVotingMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$9(args)) {
            super(...args);
        }
        else {
            super(_abi$d, _bytecode$9, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$d);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$d, signerOrProvider);
    }
}
MajorityVotingMock__factory.bytecode = _bytecode$9;
MajorityVotingMock__factory.abi = _abi$d;

/* Autogenerated file. Do not edit manually. */

var index$a = /*#__PURE__*/Object.freeze({
  __proto__: null,
  clonable: index$g,
  pluginTestSol: index$f,
  sharedPluginTestSol: index$e,
  uupsUpgradeable: index$b,
  AddresslistMock__factory: AddresslistMock__factory,
  AdminCloneFactory__factory: AdminCloneFactory__factory,
  MajorityVotingMock__factory: MajorityVotingMock__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$c = [
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "receivers",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "amounts",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct GovernanceERC20.MintSettings",
                name: "_mintSettings",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "receiversArrayLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountsArrayLength",
                type: "uint256",
            },
        ],
        name: "MintSettingsArrayLengthMismatch",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINT_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "pos",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "fromBlock",
                        type: "uint32",
                    },
                    {
                        internalType: "uint224",
                        name: "votes",
                        type: "uint224",
                    },
                ],
                internalType: "struct ERC20VotesUpgradeable.Checkpoint",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPastTotalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPastVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "receivers",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "amounts",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct GovernanceERC20.MintSettings",
                name: "_mintSettings",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "setBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$8 = "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";
const isSuperArgs$8 = (xs) => xs.length > 1;
class GovernanceERC20Mock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$8(args)) {
            super(...args);
        }
        else {
            super(_abi$c, _bytecode$8, args[0]);
        }
    }
    deploy(_dao, _name, _symbol, _mintSettings, overrides) {
        return super.deploy(_dao, _name, _symbol, _mintSettings, overrides || {});
    }
    getDeployTransaction(_dao, _name, _symbol, _mintSettings, overrides) {
        return super.getDeployTransaction(_dao, _name, _symbol, _mintSettings, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$c);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$c, signerOrProvider);
    }
}
GovernanceERC20Mock__factory.bytecode = _bytecode$8;
GovernanceERC20Mock__factory.abi = _abi$c;

/* Autogenerated file. Do not edit manually. */
const _abi$b = [
    {
        inputs: [
            {
                internalType: "string",
                name: "URI_",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
        ],
        name: "TransferBatch",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "TransferSingle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "value",
                type: "string",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "URI",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "accounts",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
        ],
        name: "balanceOfBatch",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeBatchTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "uri",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode$7 = "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";
const isSuperArgs$7 = (xs) => xs.length > 1;
class TestERC1155__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$7(args)) {
            super(...args);
        }
        else {
            super(_abi$b, _bytecode$7, args[0]);
        }
    }
    deploy(URI_, overrides) {
        return super.deploy(URI_, overrides || {});
    }
    getDeployTransaction(URI_, overrides) {
        return super.getDeployTransaction(URI_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$b);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$b, signerOrProvider);
    }
}
TestERC1155__factory.bytecode = _bytecode$7;
TestERC1155__factory.abi = _abi$b;

/* Autogenerated file. Do not edit manually. */
const _abi$a = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "amountToMint",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals_",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "setBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_decimals",
                type: "uint8",
            },
        ],
        name: "setDecimals",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$6 = "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";
const isSuperArgs$6 = (xs) => xs.length > 1;
class TestERC20__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$6(args)) {
            super(...args);
        }
        else {
            super(_abi$a, _bytecode$6, args[0]);
        }
    }
    deploy(name_, symbol_, amountToMint, overrides) {
        return super.deploy(name_, symbol_, amountToMint, overrides || {});
    }
    getDeployTransaction(name_, symbol_, amountToMint, overrides) {
        return super.getDeployTransaction(name_, symbol_, amountToMint, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$a);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$a, signerOrProvider);
    }
}
TestERC20__factory.bytecode = _bytecode$6;
TestERC20__factory.abi = _abi$a;

/* Autogenerated file. Do not edit manually. */
const _abi$9 = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$5 = "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";
const isSuperArgs$5 = (xs) => xs.length > 1;
class TestERC721__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$5(args)) {
            super(...args);
        }
        else {
            super(_abi$9, _bytecode$5, args[0]);
        }
    }
    deploy(name_, symbol_, overrides) {
        return super.deploy(name_, symbol_, overrides || {});
    }
    getDeployTransaction(name_, symbol_, overrides) {
        return super.getDeployTransaction(name_, symbol_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$9);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$9, signerOrProvider);
    }
}
TestERC721__factory.bytecode = _bytecode$5;
TestERC721__factory.abi = _abi$9;

/* Autogenerated file. Do not edit manually. */

var index$9 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GovernanceERC20Mock__factory: GovernanceERC20Mock__factory,
  TestERC1155__factory: TestERC1155__factory,
  TestERC20__factory: TestERC20__factory,
  TestERC721__factory: TestERC721__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$8 = [
    {
        inputs: [
            {
                internalType: "string",
                name: "subdomain",
                type: "string",
            },
        ],
        name: "isSubdomainValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode$4 = "0x608060405234801561001057600080fd5b5061024d806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063a6fe91aa14610030575b600080fd5b61004361003e366004610117565b610057565b604051901515815260200160405180910390f35b6000610063838361006c565b90505b92915050565b6000828280835b8181101561010a57600084848381811061008f5761008f610189565b919091013560f81c9150506060811180156100ad5750607b8160ff16105b156100b857506100f8565b602f8160ff161180156100ce5750603a8160ff16105b156100d957506100f8565b8060ff16602d036100ea57506100f8565b600095505050505050610066565b80610102816101b8565b915050610073565b5060019695505050505050565b6000806020838503121561012a57600080fd5b823567ffffffffffffffff8082111561014257600080fd5b818501915085601f83011261015657600080fd5b81358181111561016557600080fd5b86602082850101111561017757600080fd5b60209290920196919550909350505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8203610210577f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b506001019056fea26469706673582212206abc490182a5fa6da85ec289a4a51a0dfbc2de4ceff05eea73dd8265aa0cd1c164736f6c63430008110033";
const isSuperArgs$4 = (xs) => xs.length > 1;
class RegistryUtils__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$4(args)) {
            super(...args);
        }
        else {
            super(_abi$8, _bytecode$4, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$8);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$8, signerOrProvider);
    }
}
RegistryUtils__factory.bytecode = _bytecode$4;
RegistryUtils__factory.abi = _abi$8;

/* Autogenerated file. Do not edit manually. */

var index$8 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RegistryUtils__factory: RegistryUtils__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$7 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractAlreadyRegistered",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractERC165SupportInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "ContractInterfaceInvalid",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "Registered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "REGISTER_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_REGISTRY_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "entries",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "bytes4",
                name: "targetInterface",
                type: "bytes4",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "registrant",
                type: "address",
            },
        ],
        name: "register",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "targetInterfaceId",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode$3 = "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";
const isSuperArgs$3 = (xs) => xs.length > 1;
class InterfaceBasedRegistryMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$3(args)) {
            super(...args);
        }
        else {
            super(_abi$7, _bytecode$3, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$7);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$7, signerOrProvider);
    }
}
InterfaceBasedRegistryMock__factory.bytecode = _bytecode$3;
InterfaceBasedRegistryMock__factory.abi = _abi$7;

/* Autogenerated file. Do not edit manually. */
const _abi$6 = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "limit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "RatioOutOfBounds",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_ratio",
                type: "uint256",
            },
        ],
        name: "applyRatioCeiled",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "getRatioBase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode$2 = "0x608060405234801561001057600080fd5b50610236806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c80633d9de6701461003b578063a027562014610052575b600080fd5b620f42405b60405190815260200160405180910390f35b610040610060366004610109565b600061006c8383610075565b90505b92915050565b6000620f42408211156100c4576040517fcc80c195000000000000000000000000000000000000000000000000000000008152620f424060048201526024810183905260440160405180910390fd5b6100ce828461015a565b925060006100df620f4240856101a0565b90506100ee620f4240856101b4565b91508015610102576100ff826101c8565b91505b5092915050565b6000806040838503121561011c57600080fd5b50508035926020909101359150565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b808202811582820484141761006f5761006f61012b565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b6000826101af576101af610171565b500690565b6000826101c3576101c3610171565b500490565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff82036101f9576101f961012b565b506001019056fea264697066735822122061baccb4c4b0006c37e7af812a776fae1ff5847a9881e60a5447d96069782b2564736f6c63430008110033";
const isSuperArgs$2 = (xs) => xs.length > 1;
class RatioTest__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$2(args)) {
            super(...args);
        }
        else {
            super(_abi$6, _bytecode$2, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$6);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$6, signerOrProvider);
    }
}
RatioTest__factory.bytecode = _bytecode$2;
RatioTest__factory.abi = _abi$6;

/* Autogenerated file. Do not edit manually. */

var index$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  registryUtilsTestSol: index$8,
  InterfaceBasedRegistryMock__factory: InterfaceBasedRegistryMock__factory,
  RatioTest__factory: RatioTest__factory
});

/* Autogenerated file. Do not edit manually. */

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  dao: index$l,
  permission: index$j,
  plugin: index$a,
  token: index$9,
  utils: index$7
});

/* Autogenerated file. Do not edit manually. */
const _abi$5 = [
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "receivers",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "amounts",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct GovernanceERC20.MintSettings",
                name: "_mintSettings",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "where",
                type: "address",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "permissionId",
                type: "bytes32",
            },
        ],
        name: "DaoUnauthorized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "receiversArrayLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountsArrayLength",
                type: "uint256",
            },
        ],
        name: "MintSettingsArrayLengthMismatch",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINT_PERMISSION_ID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "pos",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "fromBlock",
                        type: "uint32",
                    },
                    {
                        internalType: "uint224",
                        name: "votes",
                        type: "uint224",
                    },
                ],
                internalType: "struct ERC20VotesUpgradeable.Checkpoint",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dao",
        outputs: [
            {
                internalType: "contract IDAO",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPastTotalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPastVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDAO",
                name: "_dao",
                type: "address",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "receivers",
                        type: "address[]",
                    },
                    {
                        internalType: "uint256[]",
                        name: "amounts",
                        type: "uint256[]",
                    },
                ],
                internalType: "struct GovernanceERC20.MintSettings",
                name: "_mintSettings",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode$1 = "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";
const isSuperArgs$1 = (xs) => xs.length > 1;
class GovernanceERC20__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs$1(args)) {
            super(...args);
        }
        else {
            super(_abi$5, _bytecode$1, args[0]);
        }
    }
    deploy(_dao, _name, _symbol, _mintSettings, overrides) {
        return super.deploy(_dao, _name, _symbol, _mintSettings, overrides || {});
    }
    getDeployTransaction(_dao, _name, _symbol, _mintSettings, overrides) {
        return super.getDeployTransaction(_dao, _name, _symbol, _mintSettings, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$5);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$5, signerOrProvider);
    }
}
GovernanceERC20__factory.bytecode = _bytecode$1;
GovernanceERC20__factory.abi = _abi$5;

/* Autogenerated file. Do not edit manually. */
const _abi$4 = [
    {
        inputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "_token",
                type: "address",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "pos",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "fromBlock",
                        type: "uint32",
                    },
                    {
                        internalType: "uint224",
                        name: "votes",
                        type: "uint224",
                    },
                ],
                internalType: "struct ERC20VotesUpgradeable.Checkpoint",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "depositFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPastTotalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPastVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "_token",
                type: "address",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "underlying",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawTo",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60806040523480156200001157600080fd5b50604051620034723803806200347283398101604081905262000034916200053b565b620000418383836200004a565b5050506200071f565b600054610100900460ff16158080156200006b5750600054600160ff909116105b806200009b575062000088306200019760201b62000dd61760201c565b1580156200009b575060005460ff166001145b620001045760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b60648201526084015b60405180910390fd5b6000805460ff19166001179055801562000128576000805461ff0019166101001790555b620001348383620001a6565b6200013f8362000212565b6200014a846200029c565b801562000191576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b50505050565b6001600160a01b03163b151590565b600054610100900460ff16620002025760405162461bcd60e51b815260206004820152602b60248201526000805160206200345283398151915260448201526a6e697469616c697a696e6760a81b6064820152608401620000fb565b6200020e828262000303565b5050565b600054610100900460ff166200026e5760405162461bcd60e51b815260206004820152602b60248201526000805160206200345283398151915260448201526a6e697469616c697a696e6760a81b6064820152608401620000fb565b6200029981604051806040016040528060018152602001603160f81b8152506200038160201b60201c565b50565b600054610100900460ff16620002f85760405162461bcd60e51b815260206004820152602b60248201526000805160206200345283398151915260448201526a6e697469616c697a696e6760a81b6064820152608401620000fb565b6200029981620003f7565b600054610100900460ff166200035f5760405162461bcd60e51b815260206004820152602b60248201526000805160206200345283398151915260448201526a6e697469616c697a696e6760a81b6064820152608401620000fb565b60686200036d838262000653565b5060696200037c828262000653565b505050565b600054610100900460ff16620003dd5760405162461bcd60e51b815260206004820152602b60248201526000805160206200345283398151915260448201526a6e697469616c697a696e6760a81b6064820152608401620000fb565b815160209283012081519190920120609791909155609855565b600054610100900460ff16620004535760405162461bcd60e51b815260206004820152602b60248201526000805160206200345283398151915260448201526a6e697469616c697a696e6760a81b6064820152608401620000fb565b61013080546001600160a01b0319166001600160a01b0392909216919091179055565b634e487b7160e01b600052604160045260246000fd5b600082601f8301126200049e57600080fd5b81516001600160401b0380821115620004bb57620004bb62000476565b604051601f8301601f19908116603f01168101908282118183101715620004e657620004e662000476565b816040528381526020925086838588010111156200050357600080fd5b600091505b8382101562000527578582018301518183018401529082019062000508565b600093810190920192909252949350505050565b6000806000606084860312156200055157600080fd5b83516001600160a01b03811681146200056957600080fd5b60208501519093506001600160401b03808211156200058757600080fd5b62000595878388016200048c565b93506040860151915080821115620005ac57600080fd5b50620005bb868287016200048c565b9150509250925092565b600181811c90821680620005da57607f821691505b602082108103620005fb57634e487b7160e01b600052602260045260246000fd5b50919050565b601f8211156200037c57600081815260208120601f850160051c810160208610156200062a5750805b601f850160051c820191505b818110156200064b5782815560010162000636565b505050505050565b81516001600160401b038111156200066f576200066f62000476565b6200068781620006808454620005c5565b8462000601565b602080601f831160018114620006bf5760008415620006a65750858301515b600019600386901b1c1916600185901b1785556200064b565b600085815260208120601f198616915b82811015620006f057888601518255948401946001909101908401620006cf565b50858210156200070f5787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b612d23806200072f6000396000f3fe608060405234801561001057600080fd5b50600436106101b95760003560e01c80636f307dc3116100f95780639ab24eb011610097578063c3cda52011610071578063c3cda520146103d9578063d505accf146103ec578063dd62ed3e146103ff578063f1127ed81461043857600080fd5b80639ab24eb0146103a0578063a457c2d7146103b3578063a9059cbb146103c657600080fd5b80637ecebe00116100d35780637ecebe001461035f5780638e539e8c14610372578063906571471461038557806395d89b411461039857600080fd5b80636f307dc3146102fa5780636fcfff451461030e57806370a082311461033657600080fd5b80632f4f21e2116101665780633950935111610140578063395093511461027b5780633a46b1a81461028e578063587cde1e146102a15780635c19a95c146102e557600080fd5b80632f4f21e214610246578063313ce567146102595780633644e5151461027357600080fd5b806318160ddd1161019757806318160ddd1461020e578063205c28781461022057806323b872dd1461023357600080fd5b806301ffc9a7146101be57806306fdde03146101e6578063095ea7b3146101fb575b600080fd5b6101d16101cc366004612712565b610475565b60405190151581526020015b60405180910390f35b6101ee6105ae565b6040516101dd9190612760565b6101d16102093660046127a8565b610640565b6067545b6040519081526020016101dd565b6101d161022e3660046127a8565b610658565b6101d16102413660046127d4565b61066b565b6101d16102543660046127a8565b61068f565b61026161069b565b60405160ff90911681526020016101dd565b6102126106aa565b6101d16102893660046127a8565b6106b4565b61021261029c3660046127a8565b6106f3565b6102cd6102af366004612815565b6001600160a01b03908116600090815260fe60205260409020541690565b6040516001600160a01b0390911681526020016101dd565b6102f86102f3366004612815565b61076b565b005b610130546102cd906001600160a01b031681565b61032161031c366004612815565b610778565b60405163ffffffff90911681526020016101dd565b610212610344366004612815565b6001600160a01b031660009081526065602052604090205490565b61021261036d366004612815565b61079a565b610212610380366004612832565b6107b8565b6102f86103933660046128ee565b610815565b6101ee61096a565b6102126103ae366004612815565b610979565b6101d16103c13660046127a8565b610a00565b6101d16103d43660046127a8565b610aaa565b6102f86103e7366004612973565b610ab8565b6102f86103fa3660046129cf565b610bee565b61021261040d366004612a40565b6001600160a01b03918216600090815260666020908152604080832093909416825291909152205490565b61044b610446366004612a79565b610d52565b60408051825163ffffffff1681526020928301516001600160e01b031692810192909252016101dd565b60006001600160e01b031982167f0f13099a0000000000000000000000000000000000000000000000000000000014806104d857506001600160e01b031982167f36372b0700000000000000000000000000000000000000000000000000000000145b8061050c57506001600160e01b031982167f9d8ff7da00000000000000000000000000000000000000000000000000000000145b8061054057506001600160e01b031982167fa219a02500000000000000000000000000000000000000000000000000000000145b8061057457506001600160e01b031982167fe90fb3f600000000000000000000000000000000000000000000000000000000145b806105a857507f01ffc9a7000000000000000000000000000000000000000000000000000000006001600160e01b03198316145b92915050565b6060606880546105bd90612ab0565b80601f01602080910402602001604051908101604052809291908181526020018280546105e990612ab0565b80156106365780601f1061060b57610100808354040283529160200191610636565b820191906000526020600020905b81548152906001019060200180831161061957829003601f168201915b5050505050905090565b60003361064e818585610de5565b5060019392505050565b60006106648383610f3d565b9392505050565b600033610679858285610f6a565b610684858585610ff6565b506001949350505050565b600061066483836111f0565b60006106a5611216565b905090565b60006106a56112a5565b3360008181526066602090815260408083206001600160a01b038716845290915281205490919061064e90829086906106ee908790612afa565b610de5565b60004382106107495760405162461bcd60e51b815260206004820152601f60248201527f4552433230566f7465733a20626c6f636b206e6f7420796574206d696e65640060448201526064015b60405180910390fd5b6001600160a01b038316600090815260ff602052604090206106649083611320565b6107753382611417565b50565b6001600160a01b038116600090815260ff60205260408120546105a8906114a9565b6001600160a01b038116600090815260cb60205260408120546105a8565b60004382106108095760405162461bcd60e51b815260206004820152601f60248201527f4552433230566f7465733a20626c6f636b206e6f7420796574206d696e6564006044820152606401610740565b6105a861010083611320565b600054610100900460ff16158080156108355750600054600160ff909116105b8061084f5750303b15801561084f575060005460ff166001145b6108c15760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201527f647920696e697469616c697a65640000000000000000000000000000000000006064820152608401610740565b600080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001660011790558015610902576000805461ff0019166101001790555b61090c8383611529565b610915836115a2565b61091e8461164c565b8015610964576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b50505050565b6060606980546105bd90612ab0565b6001600160a01b038116600090815260ff602052604081205480156109ed576001600160a01b038316600090815260ff602052604090206109bb600183612b0d565b815481106109cb576109cb612b20565b60009182526020909120015464010000000090046001600160e01b03166109f0565b60005b6001600160e01b03169392505050565b3360008181526066602090815260408083206001600160a01b038716845290915281205490919083811015610a9d5760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f7760448201527f207a65726f0000000000000000000000000000000000000000000000000000006064820152608401610740565b6106848286868403610de5565b60003361064e818585610ff6565b83421115610b085760405162461bcd60e51b815260206004820152601d60248201527f4552433230566f7465733a207369676e617475726520657870697265640000006044820152606401610740565b604080517fe48329057bfd03d55e49b547132e39cffd9c1820ad7b9d4c5307691425d15adf60208201526001600160a01b038816918101919091526060810186905260808101859052600090610b8290610b7a9060a001604051602081830303815290604052805190602001206116c0565b858585611729565b9050610b8d81611753565b8614610bdb5760405162461bcd60e51b815260206004820152601960248201527f4552433230566f7465733a20696e76616c6964206e6f6e6365000000000000006044820152606401610740565b610be58188611417565b50505050505050565b83421115610c3e5760405162461bcd60e51b815260206004820152601d60248201527f45524332305065726d69743a206578706972656420646561646c696e650000006044820152606401610740565b60007f6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c9888888610c6d8c611753565b6040805160208101969096526001600160a01b0394851690860152929091166060840152608083015260a082015260c0810186905260e0016040516020818303038152906040528051906020012090506000610cc8826116c0565b90506000610cd882878787611729565b9050896001600160a01b0316816001600160a01b031614610d3b5760405162461bcd60e51b815260206004820152601e60248201527f45524332305065726d69743a20696e76616c6964207369676e617475726500006044820152606401610740565b610d468a8a8a610de5565b50505050505050505050565b60408051808201909152600080825260208201526001600160a01b038316600090815260ff60205260409020805463ffffffff8416908110610d9657610d96612b20565b60009182526020918290206040805180820190915291015463ffffffff8116825264010000000090046001600160e01b0316918101919091529392505050565b6001600160a01b03163b151590565b6001600160a01b038316610e605760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f2061646460448201527f72657373000000000000000000000000000000000000000000000000000000006064820152608401610740565b6001600160a01b038216610edc5760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f20616464726560448201527f73730000000000000000000000000000000000000000000000000000000000006064820152608401610740565b6001600160a01b0383811660008181526066602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b6000610f49338361177b565b61013054610f61906001600160a01b03168484611785565b50600192915050565b6001600160a01b0383811660009081526066602090815260408083209386168352929052205460001981146109645781811015610fe95760405162461bcd60e51b815260206004820152601d60248201527f45524332303a20696e73756666696369656e7420616c6c6f77616e63650000006044820152606401610740565b6109648484848403610de5565b6001600160a01b0383166110725760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f20616460448201527f64726573730000000000000000000000000000000000000000000000000000006064820152608401610740565b6001600160a01b0382166110ee5760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201527f65737300000000000000000000000000000000000000000000000000000000006064820152608401610740565b6001600160a01b0383166000908152606560205260409020548181101561117d5760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e742065786365656473206260448201527f616c616e636500000000000000000000000000000000000000000000000000006064820152608401610740565b6001600160a01b0380851660008181526065602052604080822086860390559286168082529083902080548601905591517fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef906111dd9086815260200190565b60405180910390a3610964848484611806565b6101305460009061120c906001600160a01b0316333085611868565b610f6183836118b9565b61013054604080517f313ce56700000000000000000000000000000000000000000000000000000000815290516000926001600160a01b03169163313ce5679160048083019260209291908290030181865afa925050508015611296575060408051601f3d908101601f1916820190925261129391810190612b36565b60015b6112a05750601290565b919050565b60006106a57f8b73c3c69bb8fe3d512ecc4cf759cc79239f7b179b0ffacaa9a75d522b39400f6112d460975490565b6098546040805160208101859052908101839052606081018290524660808201523060a082015260009060c0016040516020818303038152906040528051906020012090509392505050565b81546000908181600581111561137a57600061133b846118c3565b6113459085612b0d565b600088815260209020909150869082015463ffffffff16111561136a57809150611378565b611375816001612afa565b92505b505b808210156113c757600061138e83836119ab565b600088815260209020909150869082015463ffffffff1611156113b3578091506113c1565b6113be816001612afa565b92505b5061137a565b8015611401576113ea866113dc600184612b0d565b600091825260209091200190565b5464010000000090046001600160e01b0316611404565b60005b6001600160e01b03169695505050505050565b6001600160a01b03828116600081815260fe6020818152604080842080546065845282862054949093528787167fffffffffffffffffffffffff00000000000000000000000000000000000000008416811790915590519190951694919391928592917f3134e8a2e6d97e929a7e54011ea5485d7d196dd5f0ba4d4ef95803e8e3fc257f9190a46109648284836119c6565b600063ffffffff8211156115255760405162461bcd60e51b815260206004820152602660248201527f53616665436173743a2076616c756520646f65736e27742066697420696e203360448201527f32206269747300000000000000000000000000000000000000000000000000006064820152608401610740565b5090565b600054610100900460ff166115945760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b6064820152608401610740565b61159e8282611b03565b5050565b600054610100900460ff1661160d5760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b6064820152608401610740565b610775816040518060400160405280600181526020017f3100000000000000000000000000000000000000000000000000000000000000815250611b87565b600054610100900460ff166116b75760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b6064820152608401610740565b61077581611c0c565b60006105a86116cd6112a5565b836040517f19010000000000000000000000000000000000000000000000000000000000006020820152602281018390526042810182905260009060620160405160208183030381529060405280519060200120905092915050565b600080600061173a87878787611cb2565b9150915061174781611d76565b5090505b949350505050565b6001600160a01b038116600090815260cb602052604090208054600181018255905b50919050565b61159e8282611edb565b6040516001600160a01b0383166024820152604481018290526118019084907fa9059cbb00000000000000000000000000000000000000000000000000000000906064015b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b031990931692909217909152611ef4565b505050565b611811838383611fd9565b6001600160a01b03821615801590611835575061182d82610778565b63ffffffff16155b801561185957506001600160a01b03828116600090815260fe602052604090205416155b15611801576118018283611417565b6040516001600160a01b03808516602483015283166044820152606481018290526109649085907f23b872dd00000000000000000000000000000000000000000000000000000000906084016117ca565b61159e828261200b565b6000816000036118d557506000919050565b600060016118e2846120a3565b901c6001901b905060018184816118fb576118fb612b53565b048201901c9050600181848161191357611913612b53565b048201901c9050600181848161192b5761192b612b53565b048201901c9050600181848161194357611943612b53565b048201901c9050600181848161195b5761195b612b53565b048201901c9050600181848161197357611973612b53565b048201901c9050600181848161198b5761198b612b53565b048201901c9050610664818285816119a5576119a5612b53565b04612137565b60006119ba6002848418612b69565b61066490848416612afa565b816001600160a01b0316836001600160a01b0316141580156119e85750600081115b15611801576001600160a01b03831615611a76576001600160a01b038316600090815260ff602052604081208190611a239061214d85612159565b91509150846001600160a01b03167fdec2bacdd2f05b59de34da9b523dff8be42e5e38e818c82fdb0bae774387a7248383604051611a6b929190918252602082015260400190565b60405180910390a250505b6001600160a01b03821615611801576001600160a01b038216600090815260ff602052604081208190611aac906122ad85612159565b91509150836001600160a01b03167fdec2bacdd2f05b59de34da9b523dff8be42e5e38e818c82fdb0bae774387a7248383604051611af4929190918252602082015260400190565b60405180910390a25050505050565b600054610100900460ff16611b6e5760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b6064820152608401610740565b6068611b7a8382612bd9565b5060696118018282612bd9565b600054610100900460ff16611bf25760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b6064820152608401610740565b815160209283012081519190920120609791909155609855565b600054610100900460ff16611c775760405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b6064820152608401610740565b61013080547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b0392909216919091179055565b6000807f7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0831115611ce95750600090506003611d6d565b6040805160008082526020820180845289905260ff881692820192909252606081018690526080810185905260019060a0016020604051602081039080840390855afa158015611d3d573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b038116611d6657600060019250925050611d6d565b9150600090505b94509492505050565b6000816004811115611d8a57611d8a612c99565b03611d925750565b6001816004811115611da657611da6612c99565b03611df35760405162461bcd60e51b815260206004820152601860248201527f45434453413a20696e76616c6964207369676e617475726500000000000000006044820152606401610740565b6002816004811115611e0757611e07612c99565b03611e545760405162461bcd60e51b815260206004820152601f60248201527f45434453413a20696e76616c6964207369676e6174757265206c656e677468006044820152606401610740565b6003816004811115611e6857611e68612c99565b036107755760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202773272076616c60448201527f75650000000000000000000000000000000000000000000000000000000000006064820152608401610740565b611ee582826122b9565b61096461010061214d83612159565b6000611f49826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b031661242b9092919063ffffffff16565b8051909150156118015780806020019051810190611f679190612caf565b6118015760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e60448201527f6f742073756363656564000000000000000000000000000000000000000000006064820152608401610740565b6001600160a01b03838116600090815260fe6020526040808220548584168352912054611801929182169116836119c6565b612015828261243a565b6067546001600160e01b0310156120945760405162461bcd60e51b815260206004820152603060248201527f4552433230566f7465733a20746f74616c20737570706c79207269736b73206f60448201527f766572666c6f77696e6720766f746573000000000000000000000000000000006064820152608401610740565b6109646101006122ad83612159565b600080608083901c156120b857608092831c92015b604083901c156120ca57604092831c92015b602083901c156120dc57602092831c92015b601083901c156120ee57601092831c92015b600883901c1561210057600892831c92015b600483901c1561211257600492831c92015b600283901c1561212457600292831c92015b600183901c156105a85760010192915050565b60008183106121465781610664565b5090919050565b60006106648284612b0d565b825460009081908181156121a657612176876113dc600185612b0d565b60408051808201909152905463ffffffff8116825264010000000090046001600160e01b031660208201526121bb565b60408051808201909152600080825260208201525b905080602001516001600160e01b031693506121db84868863ffffffff16565b92506000821180156121f35750805163ffffffff1643145b156122385761220183612503565b612210886113dc600186612b0d565b80546001600160e01b03929092166401000000000263ffffffff9092169190911790556122a3565b86604051806040016040528061224d436114a9565b63ffffffff16815260200161226186612503565b6001600160e01b0390811690915282546001810184556000938452602093849020835194909301519091166401000000000263ffffffff909316929092179101555b5050935093915050565b60006106648284612afa565b6001600160a01b0382166123355760405162461bcd60e51b815260206004820152602160248201527f45524332303a206275726e2066726f6d20746865207a65726f2061646472657360448201527f73000000000000000000000000000000000000000000000000000000000000006064820152608401610740565b6001600160a01b038216600090815260656020526040902054818110156123c45760405162461bcd60e51b815260206004820152602260248201527f45524332303a206275726e20616d6f756e7420657863656564732062616c616e60448201527f63650000000000000000000000000000000000000000000000000000000000006064820152608401610740565b6001600160a01b03831660008181526065602090815260408083208686039055606780548790039055518581529192917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a361180183600084611806565b606061174b8484600085612582565b6001600160a01b0382166124905760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f2061646472657373006044820152606401610740565b80606760008282546124a29190612afa565b90915550506001600160a01b0382166000818152606560209081526040808320805486019055518481527fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef910160405180910390a361159e60008383611806565b60006001600160e01b038211156115255760405162461bcd60e51b815260206004820152602760248201527f53616665436173743a2076616c756520646f65736e27742066697420696e203260448201527f32342062697473000000000000000000000000000000000000000000000000006064820152608401610740565b6060824710156125fa5760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f60448201527f722063616c6c00000000000000000000000000000000000000000000000000006064820152608401610740565b600080866001600160a01b031685876040516126169190612cd1565b60006040518083038185875af1925050503d8060008114612653576040519150601f19603f3d011682016040523d82523d6000602084013e612658565b606091505b509150915061266987838387612674565b979650505050505050565b606083156126e35782516000036126dc576001600160a01b0385163b6126dc5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e74726163740000006044820152606401610740565b508161174b565b61174b83838151156126f85781518083602001fd5b8060405162461bcd60e51b81526004016107409190612760565b60006020828403121561272457600080fd5b81356001600160e01b03198116811461066457600080fd5b60005b8381101561275757818101518382015260200161273f565b50506000910152565b602081526000825180602084015261277f81604085016020870161273c565b601f01601f19169190910160400192915050565b6001600160a01b038116811461077557600080fd5b600080604083850312156127bb57600080fd5b82356127c681612793565b946020939093013593505050565b6000806000606084860312156127e957600080fd5b83356127f481612793565b9250602084013561280481612793565b929592945050506040919091013590565b60006020828403121561282757600080fd5b813561066481612793565b60006020828403121561284457600080fd5b5035919050565b634e487b7160e01b600052604160045260246000fd5b600082601f83011261287257600080fd5b813567ffffffffffffffff8082111561288d5761288d61284b565b604051601f8301601f19908116603f011681019082821181831017156128b5576128b561284b565b816040528381528660208588010111156128ce57600080fd5b836020870160208301376000602085830101528094505050505092915050565b60008060006060848603121561290357600080fd5b833561290e81612793565b9250602084013567ffffffffffffffff8082111561292b57600080fd5b61293787838801612861565b9350604086013591508082111561294d57600080fd5b5061295a86828701612861565b9150509250925092565b60ff8116811461077557600080fd5b60008060008060008060c0878903121561298c57600080fd5b863561299781612793565b9550602087013594506040870135935060608701356129b581612964565b9598949750929560808101359460a0909101359350915050565b600080600080600080600060e0888a0312156129ea57600080fd5b87356129f581612793565b96506020880135612a0581612793565b955060408801359450606088013593506080880135612a2381612964565b9699959850939692959460a0840135945060c09093013592915050565b60008060408385031215612a5357600080fd5b8235612a5e81612793565b91506020830135612a6e81612793565b809150509250929050565b60008060408385031215612a8c57600080fd5b8235612a9781612793565b9150602083013563ffffffff81168114612a6e57600080fd5b600181811c90821680612ac457607f821691505b60208210810361177557634e487b7160e01b600052602260045260246000fd5b634e487b7160e01b600052601160045260246000fd5b808201808211156105a8576105a8612ae4565b818103818111156105a8576105a8612ae4565b634e487b7160e01b600052603260045260246000fd5b600060208284031215612b4857600080fd5b815161066481612964565b634e487b7160e01b600052601260045260246000fd5b600082612b8657634e487b7160e01b600052601260045260246000fd5b500490565b601f82111561180157600081815260208120601f850160051c81016020861015612bb25750805b601f850160051c820191505b81811015612bd157828155600101612bbe565b505050505050565b815167ffffffffffffffff811115612bf357612bf361284b565b612c0781612c018454612ab0565b84612b8b565b602080601f831160018114612c3c5760008415612c245750858301515b600019600386901b1c1916600185901b178555612bd1565b600085815260208120601f198616915b82811015612c6b57888601518255948401946001909101908401612c4c565b5085821015612c895787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b634e487b7160e01b600052602160045260246000fd5b600060208284031215612cc157600080fd5b8151801515811461066457600080fd5b60008251612ce381846020870161273c565b919091019291505056fea2646970667358221220fda67874b00bb3f45c9b670ff2669a7f6751018e8ae27da22701c5242ef5373164736f6c63430008110033496e697469616c697a61626c653a20636f6e7472616374206973206e6f742069";
const isSuperArgs = (xs) => xs.length > 1;
class GovernanceWrappedERC20__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi$4, _bytecode, args[0]);
        }
    }
    deploy(_token, _name, _symbol, overrides) {
        return super.deploy(_token, _name, _symbol, overrides || {});
    }
    getDeployTransaction(_token, _name, _symbol, overrides) {
        return super.getDeployTransaction(_token, _name, _symbol, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi$4);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$4, signerOrProvider);
    }
}
GovernanceWrappedERC20__factory.bytecode = _bytecode;
GovernanceWrappedERC20__factory.abi = _abi$4;

/* Autogenerated file. Do not edit manually. */
const _abi$3 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "depositFor",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawTo",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IGovernanceWrappedERC20__factory {
    static createInterface() {
        return new utils.Interface(_abi$3);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$3, signerOrProvider);
    }
}
IGovernanceWrappedERC20__factory.abi = _abi$3;

/* Autogenerated file. Do not edit manually. */

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GovernanceERC20__factory: GovernanceERC20__factory,
  GovernanceWrappedERC20__factory: GovernanceWrappedERC20__factory,
  IGovernanceWrappedERC20__factory: IGovernanceWrappedERC20__factory
});

/* Autogenerated file. Do not edit manually. */
const _abi$2 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IERC20MintableUpgradeable__factory {
    static createInterface() {
        return new utils.Interface(_abi$2);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$2, signerOrProvider);
    }
}
IERC20MintableUpgradeable__factory.abi = _abi$2;

/* Autogenerated file. Do not edit manually. */

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  governance: index$5,
  IERC20MintableUpgradeable__factory: IERC20MintableUpgradeable__factory
});

/* Autogenerated file. Do not edit manually. */

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  erc20: index$4
});

/* Autogenerated file. Do not edit manually. */
const _abi$1 = [
    {
        inputs: [],
        name: "protocolVersion",
        outputs: [
            {
                internalType: "uint8[3]",
                name: "_version",
                type: "uint8[3]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class IProtocolVersion__factory {
    static createInterface() {
        return new utils.Interface(_abi$1);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi$1, signerOrProvider);
    }
}
IProtocolVersion__factory.abi = _abi$1;

/* Autogenerated file. Do not edit manually. */
const _abi = [
    {
        inputs: [],
        name: "protocolVersion",
        outputs: [
            {
                internalType: "uint8[3]",
                name: "",
                type: "uint8[3]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
class ProtocolVersion__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
ProtocolVersion__factory.abi = _abi;

/* Autogenerated file. Do not edit manually. */

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IProtocolVersion__factory: IProtocolVersion__factory,
  ProtocolVersion__factory: ProtocolVersion__factory
});

/* Autogenerated file. Do not edit manually. */

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  protocol: index$2
});

/* Autogenerated file. Do not edit manually. */

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  core: index$I,
  framework: index$B,
  plugins: index$o,
  test: index$6,
  token: index$3,
  utils: index$1
});

const activeContractsList = activeContracts;

export { ActionExecute__factory, AddresslistMock__factory, AddresslistVotingSetup__factory, AddresslistVoting__factory, Addresslist__factory, AdminCloneFactory__factory, AdminSetup__factory, Admin__factory, CallbackHandlerMockHelper__factory, CallbackHandler__factory, CounterV1PluginSetup__factory, CounterV1__factory, CounterV2PluginSetup__factory, CounterV2__factory, DAOFactory__factory, DAOMock__factory, DAORegistry__factory, DAO__factory, DaoAuthorizableUpgradeable__factory, DaoAuthorizable__factory, ENSSubdomainRegistrar__factory, ERC1271Mock__factory, GasConsumer__factory, GovernanceERC20Mock__factory, GovernanceERC20__factory, GovernanceWrappedERC20__factory, IDAO__factory, IEIP4824__factory, IERC20MintableUpgradeable__factory, IGovernanceWrappedERC20__factory, IMajorityVoting__factory, IMembership__factory, IMerkleDistributor__factory, IMerkleMinter__factory, IMultisig__factory, IPermissionCondition__factory, IPluginRepo__factory, IPluginSetup__factory, IPlugin__factory, IProposal__factory, IProtocolVersion__factory, InterfaceBasedRegistryMock__factory, InterfaceBasedRegistry__factory, MajorityVotingBase__factory, MajorityVotingMock__factory, MerkleDistributor__factory, MerkleMinter__factory, MultiplyHelper__factory, MultisigSetup__factory, Multisig__factory, PermissionConditionMock__factory, PermissionConditionUpgradeable__factory, PermissionCondition__factory, PermissionLib__factory, PermissionManagerTest__factory, PermissionManager__factory, PlaceholderSetup__factory, PluginCloneableSetupV1MockBad__factory, PluginCloneableSetupV1Mock__factory, PluginCloneableSetupV2Mock__factory, PluginCloneableV1MockBad__factory, PluginCloneableV1Mock__factory, PluginCloneableV2Mock__factory, PluginCloneable__factory, PluginRepoFactory__factory, PluginRepoRegistry__factory, PluginRepo__factory, PluginSetupProcessor__factory, PluginSetup__factory, PluginUUPSUpgradeableSetupV1MockBad__factory, PluginUUPSUpgradeableSetupV1Mock__factory, PluginUUPSUpgradeableSetupV2Mock__factory, PluginUUPSUpgradeableSetupV3Mock__factory, PluginUUPSUpgradeableSetupV4Mock__factory, PluginUUPSUpgradeableV1Mock__factory, PluginUUPSUpgradeableV2Mock__factory, PluginUUPSUpgradeableV3Mock__factory, PluginUUPSUpgradeable__factory, Plugin__factory, ProposalUpgradeable__factory, Proposal__factory, ProtocolVersion__factory, RatioTest__factory, RegistryUtils__factory, TestERC1155__factory, TestERC20__factory, TestERC721__factory, TestIdGatingCondition__factory, TestParameterScopingPermissionCondition__factory, TestPlugin__factory, TestSharedPlugin__factory, TokenFactory__factory, TokenVotingSetup__factory, TokenVoting__factory, activeContractsList, index as factories };
